import { useAuth0, withAuth0 } from "@auth0/auth0-react";
import DateFnsUtils from "@date-io/date-fns";
import Grid from "@material-ui/core/Grid";
import {
    KeyboardDateTimePicker,
    MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import IconButton from "@mui/material/IconButton";
import axios from "axios";
import "date-fns";
import { Popup } from "devextreme-react/popup";
import moment from "moment-timezone";
import { Fragment, useCallback, useContext, useEffect, useState } from "react";
import { Button, ButtonGroup } from "react-bootstrap";
import { connect, useSelector } from "react-redux";
import BookAnAppointment from "../Components/BookAnAppointment/BookAnAppointment";
import RequestTable from "../Components/activityRequestTable/RequestTable";
import {
    API_URL,
    GpServicesToShowDoctorList,
    RELOAD_CONVERSATION_WORKFLOW,
    SuccessfulCallOrderStatus,
    cardiacDiagnosisList,
    getOrderStatusDetails,
    insuranceTypeList,
} from "../ConstVariable";
import GoogleCalendarIcon from "../Logo/googelCalendar.png";
import Loading from "../Logo/loader.gif";
import Input from "../UI/Input";
import CustomModal from "../UI/Modal";
import SelectBoxDropDown from "../UI/SelectBoxDropDown";
import {
    ClearError,
    SetError,
    SetSelectedWorkdeskConversation,
    StatusCode,
    setDataFetchingStatus,
} from "../redux-store/actions";
import { requestGuidelineText } from "../requestMethod/services";
import AddmoreOrder from "./AddmoreOrder/AddmoreOrder";
import "./CallHistoryOrderForm.css";
import GuidelineDropDown from "./GuidelineDropDown";
import "./OrderButton.css";
import "./OrderDetails.css";
import OrderScanDetails from "./OrderScanDetails";
import OrderValidation from "./OrderValidation";
import ReferralFormProcessedCheckbox from "./ReferralFormProcessedCheckbox";

import MessageIcon from "@mui/icons-material/Message";
import SendIcon from "@mui/icons-material/Send";
import { QueryMethod } from "../Middleware/QueryMethod";
import PatientList from "./CheckPatientInBp/PatientList";
// import styled from "styled-components";
import CloseIcon from "@mui/icons-material/Close";
import { TextArea } from "devextreme-react";
import styled from "styled-components";
import ManualOrder from "../Components/ManualOrder/NewOrder/NewManualOrder";
import { MyContext } from "../Components/context/ContextProvider";
import DirectCallOrder from '../Components/directCallOrder/DirectCallOrder';
import InputNoError from "../UI/InputNoError";
import { GET_DIRECT_CALL_DETAILS } from "../utils/endPoints";
import GpOrderDetails from "./GpOrderDetails";
import ImagingOrderDetails from "./ImagingOrderDetails";
import OperatorHelpNotes from "./OperatorHelpNotes";

import { useHistory } from 'react-router-dom';
import RoomRow from "./RoomRow";
const ManualBookingResaonContainer = styled.div``;
const ManualBookingText = styled.p`
  padding-top: 5px;
`;

const AppointmentCaldendarButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 10px;
  background: #addee6;
  width: 45%;
  margin-top: 5px;
  border: 1px solid gray;
  border-radius: 5px;
  outline: none;
`;

const SlotDurationWrapper = styled.div`
  display: flex;
  align-item: center;
  margin-top: 5px;
`;

const SlotDurationText = styled.div``;
const SlotDurationInput = styled.div``;

const CustomButtonWithLoading = (props) => {
    return (
        <button
            disabled={props?.disabled === true ? true : false}
            className="btn btn-primary"
            type="button"
            onClick={props.clickHandler}
            style={{
                padding: "3px 10px",
                marginLeft: "10px",
                ...props.customStyle,
            }}
        >
            {!props.isUpdating ? (
                <span
                    style={{
                        fontWeight: "bold",
                        fontSize: "10px",
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    {props.buttonText} {props?.Icon}
                </span>
            ) : (
                <span>
                    {" "}
                    <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                    ></span>
                    {props.loadingText}
                </span>
            )}
        </button>
    );
};

const CustomMessagePopup = (props) => {
    const { PauseAudio } = useContext(MyContext);
    const [pause_audio, setPauseAudio] = PauseAudio;
    setPauseAudio(false)

    const renderTitle = () => {
        return (
            <div className="renderTitle">
                <div
                    style={{ fontSize: "20px", fontWeight: "600", marginBottom: "5px" }}
                >
                    {" "}
                    {props.title}
                </div>
                <IconButton>
                    <CloseIcon
                        onClick={() => props.popupHandler(!props.visible)}
                        style={{ fontSize: "25px" }}
                    />
                </IconButton>
            </div>
        );
    };

    return (
        <Popup
            id="popup"
            visible={props.visible}
            closeOnOutsideClick={false}
            onHiding={() => props.popupHandler(!props.visible)}
            // title={props.title}
            showTitle={true}
            titleRender={renderTitle}
            // contentRender={PatientList}
            resizeEnabled={true}
            width={props.width}
            height={props.height}
        >
            {props.children}
        </Popup>
    );
};

const MessageTextBox = (props) => {
    const [textInput, setTextInput] = useState("");
    const [isMessageSent, setIsMessageSent] = useState(false);
    const [isRequestProcessing, setIsRequestProcessing] = useState(false);
    const [gotAnError, setGotAnError] = useState({
        code: null,
        message: "",
        got_an_error: false,
    });

    useEffect(() => {
        if (props.shouldCleanTextArea) {
            setTextInput("");
            setIsMessageSent(false);
            setGotAnError({
                code: null,
                message: "",
                got_an_error: false,
            });
        }
        return () => {
            setTextInput("");
        };
    }, [props.shouldCleanTextArea]);

    const messageSendHandler = () => {
        if (textInput.trim().length === 0) {
            setGotAnError({
                code: 104,
                message: "Please type the message",
                got_an_error: true,
            });
            return;
        }
        setGotAnError({
            code: null,
            message: "",
            got_an_error: false,
        });

        let Data = { conversation_id: props.conversation_id, message: textInput };

        let URL = `${API_URL}/oi/api/v2/send-custom-message`;
        QueryMethod(URL, setIsRequestProcessing, Data, "POST")
            .then((response) => {
                setIsRequestProcessing(false);

                if (response.data.error_code === 100) {
                    setGotAnError({
                        code: response.data.error_code,
                        message: response.data.error_description,
                        got_an_error: false,
                    });
                    props.popupHandler();
                } else {
                    setGotAnError({
                        code: response.data.error_code,
                        message: response.data.error_description,
                        got_an_error: true,
                    });
                }
            })
            .catch((error) => {
                setGotAnError({
                    code: 103,
                    message: "Failed to send SMS successfully",
                    got_an_error: true,
                });
                console.log("Error", error);
            });
        // setIsMessageSent(true)
    };

    const inputChangeHandler = (e) => {
        setTextInput(e.target.value);
        const regex = /(http:\/\/|https:\/\/|www\.)/;

        if (regex.test(e.target.value.trim())) {
            setGotAnError({
                code: "E-102",
                message: "The SMS text contains a URL.",
                got_an_error: true,
            });
        }
        else {
            setGotAnError({
                code: "",
                message: "",
                got_an_error: false,
            });
        }

        if (e.target.value.trim().length === 1) {
            setGotAnError({
                code: null,
                message: "",
                got_an_error: false,
            });
        }
    };

    return (
        <Fragment>
            <div className="textboxarea">
                <div>
                    <textarea
                        onChange={inputChangeHandler}
                        value={textInput}
                        className="textArea"
                    />
                </div>
                <CustomButtonWithLoading
                    disabled={gotAnError.got_an_error}
                    isUpdating={isRequestProcessing}
                    clickHandler={messageSendHandler}
                    buttonText="Send SMS"
                    loadingText="Sending a message...."
                    Icon={<SendIcon style={{ marginLeft: "10px" }} />}
                    customStyle={{ margin: "20px" }}
                />
                {gotAnError.code && (
                    <p
                        style={{
                            color: gotAnError.code === 100 ? "green" : "orange",
                            marginTop: "-7px",
                        }}
                    >
                        {" "}
                        {gotAnError.message}
                    </p>
                )}
            </div>
        </Fragment>
    );
};

// Initial State of imaging appointmnet details
// Any new state to be added here
let imagingAppointmentDetails = {
    aIAllowedToBookAppointmentInClientDatabase: null,
    appointment_length: "",
    appointment_length_2:"",
    bodypart: "",
    bodypartGroup: "",
    call_status: "",
    CallStatusCode: "",
    center_list: "",
    centerId: "",
    center_prefix: "",
    comment: "",
    contact: "",
    DOB: "",
    email_id: "",
    first_name: "",
    Guidelines: "",
    guidelineRequest: false,
    isOrderBooked_By_Operator: "false",
    img_appointment_id: "",
    img_appointment_new_patient_created: "",
    img_appointment_temporary_id: "",
    isReferralFormMandatory: true,
    IsReferral: "",
    last_name: "",
    laterality: "",
    modality: "",
    Operator_Feedback: "",
    operatorFeedbackOptions: "",
    PostError: false,
    ReferralChecked: false,
    SaveClicked: false,
    schedule_datetime: "",
    SelectStatus: false,
    send_instructions_over_email: false,
    startDate: "",
    time: "",
    preparation_id: "",
    ReferralReq: "",
    ReferralbuttonHandle: "",
    PreparationResponse: "",
    purposeOfStudy: "",
    protocol: "",
    request_log: "",
    order_description: "",
    number_of_itemlist: "",
    initiator_source: "",
    selectedCenterId: null,
    is_center_details_confirmed: "",
    roomName: "",
    reserved_slot_text: "",
    roomName_2: "",
    reserved_slot_text_2: "",
    initiatorSource: null,
    reason_for_manual_booking: null,
    weeks_since_pregnant: "",
    is_pregnancy_flow: false,
    modalityGeneric: "",
    bodypartGeneric: "",
    protocolGeneric: "",
    purposeOfStudyGeneric: "",
    lateralityGeneric: "",
    bodypartGroupGeneric: "",
    pms_patient_id: "",
    pms_patient_guidance_id: null,
    speciality: "",
    send_notification:null,
    is_service_excluded_for_preparation_guideline_check:false,
    ris_service_code:"",
    ris_service_code_2:"",
};

// Initial State of GP Appointment details
let gpAppointmentDetails = {
    center_id: "",
    center_list: "",
    dateOfBirth: "",
    doctor_pms_ref_id: "",
    doctorList: "",
    insuranceNumber: "",
    insuranceType: "",
    bp_appointment_temporary_id: "",
    bp_appointment_id: "",
    cardiac_diagnosis: "",
    cardiac_diagnosis_list: [],
    gp_requested_service: "",
    appointment_to_be_booked_manually: "",
    pms_patient_guidance_id: null,
    bp_appointment_new_patient_created: 0,
    pms_patient_id: null,
    doctorName: "",
    appointment_length: 0,
    pms_landline: "",
    pms_mobile: "",
    gp_appointment_type: "",
    birth_sex: ""
};

let directCallInitialDetail = {
    dob: null,
    call_source: "",
    customer_id: "",
    call_source_text: "",
    call_context: "",
    call_context_text: "",
    name: "",
    contact: "",
    note: "",
}
//OrderDetails Component

const OrderDetails = ({
    recordsLoading,
    getTokenFunc,
    fetchedLiveOrder,
    errorForDisplay,
    SetErrorForDisplay,
    ClearErrorForDisplay,
    setStatusCode,
    showtestcallfunc,
    operatorName,
    operatorEmail,
    onSaveFetchingAllCallList,
    componentIdentity: pageName,
    setDataFetchingStatus,
    SetSelectedWorkdeskConversation,
    updateCallStatusInCallCard
}) => {
    const history = useHistory();
    const state = useSelector((state) => state);
    const [centerList, setCenterList] = useState([]);
    const [showDoctorCalender, setShowDoctorCalender] = useState(false);
    const [fetchOperatorNotes, setFetchOperatorNotes] = useState(false)
    let conversationID = state.SelectedConversationId;
    let ReferralPresent = state.ReferralFormPresent;
    let InitialTime = state.initial_time;
    //NOTE:- To show the disconnect call , manitaining the state
    const [showDisconnectButton, setShowDisconnectButton] = useState(false);
    const [obaiTaskDetails, setObaiTaskDetails] = useState(null);
    const [directCallDetails, setDirectCallDetails] = useState({ ...directCallInitialDetail })
    const { isAuthenticated, logout, getAccessTokenSilently } = useAuth0();
    const [isPreparationGuidelineLoading, setIsPreparationGuidelineLoading] = useState(false)
    const LogoutFunc = () => {
        logout({ returnTo: window.location.origin });
    };
    const [orderSaved, setOrderSaved] = useState([]);
    const [getErrorToFetchGuideline, setGetErrorToFetchGuideline] =
        useState(false);

    // NOTE :- To immediate udate ,i made this one seperate state , In orderObj , there is a state callStatusCode but it is not updating
    //immediate that's why i made this on new state
    const [showCallStatusCode, setShowCallStatusCode] = useState("");

    let RemovedStatusCode = null;

    //NOTE:- to fetch Data again on order save

    const [refRequestError, setRefRequestError] = useState({
        error_code: "0",
        error_description: "",
    });

    InitialTime = new Date(InitialTime);

    //NOTE:- Workflow Identifier
    const [workFlowIdentifier, setWorkFlowIdentifier] = useState("IMAGING_WORKFLOW");

    const [orderObj, setOrderObj] = useState({ ...imagingAppointmentDetails });


    const [gpOrderDetails, setGpOrderDetails] = useState({
        ...gpAppointmentDetails,
    });

    const [isScanSearchBeingProcess, setIsScanSearchBeingProcess] =
        useState(false);

    const [isCommentUpdating, setIsCommentUpdating] = useState(false);
    const [comradErrorList, setcomradErrorList] = useState([]);

    const [guideLineDetail, setGuideLineDetail] = useState({
        doc_name: "",
        guide_line: "",
    });

    const [guideLineStatus, setGuideLineStatus] = useState(false);

    // const GpServicesToShowDoctorList =["DOCTOR_NEW_APPT", "BLOOD_OR_ALLERGY_TEST"]

    //PopUp visible State

    const { PauseAudio } = useContext(MyContext);
    const [pause_audio, setPauseAudio] = PauseAudio;

    const [popupVisible, setPopupVisible] = useState(false);
    const [initialOrderDetails,setInitialOrderDetails]=useState(null)

    const [isOrderBeingSave, setIsOrderBeingSave] = useState(false);

    // Saving the Order On confrim in the GP call based on the patient validation
    useEffect(() => {
        if (
            workFlowIdentifier === "GP_WORKFLOW" &&
            gpOrderDetails.pms_patient_guidance_id != null
        ) {
            sendGpOrderDetails();
        }
        if (
            workFlowIdentifier === "IMAGING_WORKFLOW" &&
            orderObj.pms_patient_guidance_id != null
        ) {
            sendAppointmentDataFunc();
        }
    }, [
        gpOrderDetails.pms_patient_guidance_id,
        orderObj.pms_patient_guidance_id,
    ]);

    //

    const [time, settime] = useState("");

    // To refresh the all local state
    const resetAllStateVariables = () => {
        setOrderObj({ ...imagingAppointmentDetails });

        setGpOrderDetails({ ...gpAppointmentDetails });

        setGuideLineDetail({
            doc_name: "",
            guide_line: "",
        });
        setSelectDateTime(null); // clearing the selected date and time
        setSelectDateTime2(null);
        setWorkFlowIdentifier("IMAGING_WORKFLOW");
        setCenterList([]);
        setGetErrorToFetchGuideline(() => false);
        setcomradErrorList([]);
        setIsScanSearchBeingProcess(false);
        setFetchOperatorNotes(false);
    };

    const getParentConversationIdFromChildOrder = (conversationId) => {
        let index = conversationId.indexOf("_");
        return conversationId.substring(0, index);
    };

    const testCallback = useCallback(() => {
        setShowDisconnectButton(false);
    }, [conversationID]);
    useEffect(() => {
        testCallback();
    }, [conversationID]);

    //Fetching the guideline text
    const fetchRequestGuideLineText = async () => {
        if (isProvisionalBooking() === true) {
            return;
        }
        const token = await getTokenFunc();
        const preparation_id = orderObj.preparation_id;
        const center_id = orderObj.centerId;

        let url = `${API_URL}/oi/api/v1/get_preparation_guideline_text`;
        let requestData = {
            center_id: center_id,
            preparation_id: preparation_id,
        };

        // If Operator select the auto generate guidelines
        if (preparation_id === -1 && isProvisionalBooking() === false) {
            url = `${API_URL}/oi/api/get-auto-preparation-guideline`;
            requestData = {
                center_id: orderObj.centerId,
                modality: orderObj.modality,
                bodypart: orderObj.bodypart,
                bodypart_group: orderObj.bodypart_group,
                protocol: orderObj.protocol,
                purpose_of_study: orderObj.purpose_of_study,
                laterality: orderObj.laterality,
                modality_generic: orderObj.modalityGeneric,
                bodypart_generic: orderObj.bodypartGeneric,
                protocol_generic: orderObj.protocolGeneric,
                purpose_of_study_generic: orderObj.purposeOfStudyGeneric,
                laterality_generic: orderObj.lateralityGeneric,
                bodypart_group_generic: orderObj.bodypartGroupGeneric,
                speciality: orderObj.speciality,
                procedure_description: orderObj.order_description,
                appointment_datetime: moment(selectDateTime).isValid() ? moment(selectDateTime).format("yyyy-MM-DD HH:mm:ss") : null,
                conversation_id: conversationID

            };
        }

        const data = await requestGuidelineText(
            url,
            center_id,
            preparation_id,
            token,
            setGuideLineStatus,
            requestData,
            setIsPreparationGuidelineLoading
        );

        setOrderObj((prevState) => {
            return {
                ...prevState,
                PreparationResponse: data,
            };
        });

        setGuideLineStatus(true);
        if (Object.keys(data).length === 0) {
            setGuideLineDetail({
                doc_name: "",
                guide_line: "",
            });
        } else if (Object.keys(data).length !== 0 && data.error) {
            setGetErrorToFetchGuideline(true);
            SetErrorForDisplay({ severity: "warning", message: data.message });
        } else if (data?.error_code && data?.error_code != 0) {
            setGetErrorToFetchGuideline(true);

            SetErrorForDisplay({
                severity: "warning",
                message: data?.error_description,
            });
        } else {
            setGetErrorToFetchGuideline(false);

            let guideline = "";
            if (
                data !== undefined &&
                data !== "" &&
                data.preparation_guideline_text
            ) {
                guideline = data.preparation_guideline_text.split("\n");
            }
            setGuideLineDetail({
                doc_name: data.doc_name,
                guide_line: guideline,
            });
        }
    };
    //To get the Guideline text
    useEffect(() => {
        if (
            orderObj.preparation_id &&
            orderObj.centerId &&
            orderObj.CallStatusCode &&
            conversationID
        ) {
            fetchRequestGuideLineText();
        }
    }, [
        orderObj.preparation_id, orderObj.contact

    ]);

    //*********************************************************8 */
    const [orderListArray, setOrderListArray] = useState([]);

    const [rerender, setRerender] = useState(false);

    const addExtraOrderhandler = () => {
        setRerender(true);
        let Order = {
            modality: "",
            bodypart: "",
            protocol: "",
            purpose_of_study: "",
            laterality: "",
            bodypart_group: "",
            order_description: "",
            schedule_datetime: null,
            roomName: "",
            reserved_slot_text: "",
            is_pregnancy_flow: false,
            weeks_since_pregnant: "",
            modalityGeneric: "",
            bodypartGeneric: "",
            protocolGeneric: "",
            purposeOfStudyGeneric: "",
            lateralityGeneric: "",
            bodypartGroupGeneric: "",
            speciality: "",
            conversationID: conversationID + "-" + orderListArray.length,
            ris_service_code: "",
            appointment_length:0 
        };

        setOrderListArray((preview) => [...preview, Order]);
    };

    //************************************************** */

    const fetchOrderDetails = async (callSource) => {


        try {
            let url = `${API_URL}/oi/api/v1/cart/${conversationID}`
            if (callSource === "DIRECT_CALL") {
                url = `${GET_DIRECT_CALL_DETAILS}?conversation_id=${conversationID}`

            }
            const token = await getTokenFunc();
            setSelectDateTime(null);
            setSelectDateTime2(null);
            setShowCallStatusCode("");

            if (conversationID) {
                //Setting the data fetching status as true
                setDataFetchingStatus(true);
                // alert("Order Details fetched");
                await fetch(url, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    credentials: "include"
                })
                    .then((response) => response.json())
                    .then((data) => {

                        displayOrderData(data, conversationID);
                        console.log("data",data)

                        setDataFetchingStatus(false);
                    })
                    .catch((error) => {
                        setDataFetchingStatus(false);
                        SetErrorForDisplay({
                            severity: "warning",
                            message: "Failed to fetch the Order details",
                        });
                        console.log("Error", error);
                    });
            }
        } catch (error) {
            setDataFetchingStatus(false);
            console.log("Error", error.message);
            SetErrorForDisplay({
                severity: "warning",
                message: "Failed to fetch the Order details",
            });
        }
    };

    function compare(a, b) {
        if (a.doctor_name < b.doctor_name) {
            return -1;
        }
        if (a.doctor_name > b.doctor_name) {
            return 1;
        }
        return 0;
    }

    useEffect(() => {
        if (conversationID) {

            fetchOrderDetails(state.CallSource);
            setOrderListArray([]);
        }

        return () => {
            resetAllStateVariables();
        };
    }, [conversationID]);



    useEffect(() => {
        displayLiveOrderData(conversationID, fetchedLiveOrder);
    }, [fetchedLiveOrder, conversationID]);

    const displayLiveOrderData = (conversationID, LiveOrderData) => {
        if (conversationID === LiveOrderData.conversation_id) {
            displayOrderData(LiveOrderData, conversationID);
        }
    };

    const displayOrderData = (data, conversationID) => {
        console.log("🚀 ~ file: OrderDetails.js:719 ~ displayOrderData ~ data", data)
        // return
        setInitialOrderDetails(data);
        if (data.conversation_workflow_type === "GP_WORKFLOW") {
            setWorkFlowIdentifier("GP_WORKFLOW");
            setGpAppointmentDetails(data);

        } else if (data?.conversation_workflow_type === "OBAI_WORKFLOW") {
            setWorkFlowIdentifier("OBAI_WORKFLOW");
            setObaiTaskDetails(data);
        } else if (data?.data?.conversation_workflow_type === "DIRECT_CALL") {
            setDirectCallDetails(data?.data)
            setWorkFlowIdentifier("DIRECT_CALL");

        }


        else {
            setAppointmentOrderDetails(data);
            setWorkFlowIdentifier("IMAGING_WORKFLOW");
        }
    };

    // sendNotificationHandler changes the default value of 'send_notification'. 
    // For codes 1001, 1002, 1004, 2004, and 3007, the default value is true; 
    // otherwise, it's false. 
    // The default value for AI test calls is also false. Based on user activity, it determines whether to send the message.

    const sendNotificationHandler=(operator_feedback_code)=>{
        if (operator_feedback_code && (operator_feedback_code === 1001 || operator_feedback_code === 1002 || operator_feedback_code === 1004 || operator_feedback_code === 2004 || operator_feedback_code === 3007 )) {
            setOrderObj((prevState) => {
                return {
                    ...prevState,
                    send_notification: true
                };
            })
        }else{
            
            setOrderObj((prevState) => {
                return {
                    ...prevState,
                    send_notification: false
                };
            })
        }
    }

    const setAppointmentOrderDetails = (data) => {
        console.log("🚀 ~ file: OrderDetails.js:755 ~ setAppointmentOrderDetails ~ data:", data)


        setOrderObj((prevState) => {
            return { ...prevState, ReferralReq: "", ReferralbuttonHandle: "" };
        });
        // setOrderObj({ ...orderObj, ReferralReq: "", ReferralbuttonHandle: "" });

        Object.keys(data).forEach(function (key) {
            if (
                data[key] === null ||
                data[key] === "None" ||
                typeof data[key] === "undefined"
            ) {
                data[key] = "";
            }
        });

        let DateOfBirth = "";
        if (data.date_of_birth) {
            var [year, month, day] = data.date_of_birth.split("-");
            DateOfBirth = `${day}/${month}/${year}`;
        }

        if (data.schedule_datetime) {
            setSelectDateTime(new Date(data.schedule_datetime));
            setSelectDateTime(moment(new Date(data.schedule_datetime)).format("YYYY-MM-DD HH:mm:ss"));
        } else {
            setSelectDateTime(null);
        }

        if (data.schedule_datetime_2) {
            setSelectDateTime2(new Date(data.schedule_datetime_2));
            setSelectDateTime2(moment(new Date(data.schedule_datetime_2)).format("YYYY-MM-DD HH:mm:ss"));
        } else {
            setSelectDateTime2(null);
        }
        setShowCallStatusCode(data["operator_feedback"]["operator_feedback"]);

        //NOTE:- Center List
        let centerListArry = [];
        if (data?.center_list) {

            data?.center_list?.forEach((item) =>
                centerListArry.push({
                    center_name: item.center_prefix
                        ? `${item.center_prefix} -${item.center_name}`
                        : item.center_name,
                    center_id: item.center_id,
                })
            );
        }
        setCenterList(() => [...centerListArry]);


        const modifiedGuideLineList = [
            { preparation_id: -1, doc_name: "Auto-generate-guideline" },
            ...data?.preparation_guideline_list,
        ];
    let operatorFeedbackOptions= data["operator_feedback_options"]

    let user_profile_is_customer=user?.oi_profile && user?.oi_profile?.toLowerCase() == "customer"
        
    if(user_profile_is_customer){
        operatorFeedbackOptions=operatorFeedbackOptions?.filter((operator_feedback_obj)=>{
            if(operator_feedback_obj?.operator_feedback!="2004"){
                return operator_feedback_obj
              }
          })  
    }else{
        operatorFeedbackOptions=operatorFeedbackOptions?.filter((operator_feedback_obj)=>{
            if(operator_feedback_obj?.operator_feedback!="2008" ){
              return operator_feedback_obj
            }
          })
    }


        setOrderObj((prevState) => {
            return {
                ...prevState,
                modality: data?.modality.toUpperCase(),
                bodypart: data?.bodypart.toUpperCase(),
                purposeOfStudy: data?.purpose_of_study.toUpperCase(),
                protocol: data?.protocol.toUpperCase(),
                bodypartGroup: data?.bodypart_group.toUpperCase(),
                laterality: data?.laterality.toUpperCase(),

                first_name: data.first_name,
                last_name: data.last_name,
                DOB: DateOfBirth,
                operatorFeedbackOptions:  operatorFeedbackOptions,
                Operator_Feedback: data["operator_feedback"],
                contact: data["mobile_number"],
                call_status: data.call_status,
                comment: data.feedback,
                CallStatusCode: data["operator_feedback"]["operator_feedback"],
                IsReferral: data.is_referral_present,
                isOrderBooked_By_Operator: data.isOrderBooked_By_Operator,
                Guidelines: modifiedGuideLineList,
                preparation_id: data.preparation_id,
                order_description: data.order_description,
                isReferralFormMandatory:
                    data.is_referral_form_mandatory === ""
                        ? true
                        : data.is_referral_form_mandatory,
                request_log: data.request_log,
                number_of_itemlist: data.number_of_itemlist,
                centerId: data.center_id,
                initiator_source: data.initiator_source,
                center_list: data.center_list,
                is_center_details_confirmed: data.is_center_details_confirmed,
                selectedCenterId: data.center_id,
                roomName: data.room_name,
                reserved_slot_text: data.reserved_slot_text,
                initiatorSource: data.initiator_source,
                reason_for_manual_booking: data.reason_for_manual_booking,
                weeks_since_pregnant: !data.weeks_since_pregnant
                    ? ""
                    : data.weeks_since_pregnant,
                is_pregnancy_flow: data.is_pregnancy_flow,
                center_prefix: data.center_prefix,
                img_appointment_temporary_id: data.temporary_pms_appointment_id,
                img_appointment_id: data.bp_appointment_id,
                img_appointment_new_patient_created:
                    data.bp_appointment_new_patient_created,
                pms_patient_id: data.pms_patient_id,
                appointment_length: data.appointment_length,
                ReferralChecked: data?.referral_form_status === "Processed" ? true : false,
                modalityGeneric: data?.modality_generic,
                bodypartGeneric: data?.bodypart_generic,
                protocolGeneric: data?.protocol_generic,
                purposeOfStudyGeneric: data?.purpose_of_study_generic,
                lateralityGeneric: data?.laterality_generic,
                bodypartGroupGeneric: data?.bodypart_group_generic,
                speciality: data?.speciality,
                aIAllowedToBookAppointmentInClientDatabase: data?.AI_allowed_to_book_appointment_in_client_database,
                conversation_tags_data: data?.conversation_tags_data,
                conversation_context: data?.conversation_context,
                send_instructions_over_email: data?.send_instructions_over_email || data?.is_patient_email_required,
                email_id: data?.email_id,
                send_notification: [1001, 1002, 1004, 2004, 3007].includes(data["operator_feedback"]?.operator_feedback) ?true:false,
                server_timezone:data?.server_timezone,
                center_timezone:data?.center_timezone,
                is_service_excluded_for_preparation_guideline_check:data?.is_service_excluded_for_preparation_guideline_check,
                consider_contact_no_for_patient_matching:data?.consider_contact_no_for_patient_matching?data?.consider_contact_no_for_patient_matching:false,
                roomName_2: data?.room_name_2,
                reserved_slot_text_2: data?.reserved_slot_text_2,
                schedule_datetime_2: data?.schedule_datetime_2,
                appointment_length_2: data?.appointment_length_2,
                ris_service_code:data?.ris_service_code,
                ris_service_code_2:data?.ris_service_code_2
            };
        });
        if (data?.order_description) {
            operatorNotesFetchHandler(true)
        }
    };

    const setGpAppointmentDetails = (data) => {
        let doctor_list = [
        ];

        if (data.doctorList && Array.isArray(data.doctorList)) {
            doctor_list = [
                ...doctor_list,
                ...data?.doctorList,
            ];
        }



        let sorted_doctor_list = doctor_list.sort(compare);
        sorted_doctor_list = [{ doctor_pms_ref_id: null, doctor_name: "All Doctor" }, ...sorted_doctor_list]





        setGpOrderDetails((prevState) => {
            return {
                ...prevState,

                doctor_pms_ref_id: data.doctor_pms_ref_id,
                insuranceNumber: data.insuranceNumber,
                gp_requested_service: data.gp_requested_service,
                bp_appointment_temporary_id: data.temporary_pms_appointment_id,
                bp_appointment_id: data.bp_appointment_id,
                doctorName: data.doctorName,
                center_id: data.center_id,
                appointment_to_be_booked_manually:
                    data.appointment_to_be_booked_manually,
                bp_appointment_new_patient_created:
                    data.bp_appointment_new_patient_created,
                pms_patient_id: data.pms_patient_id,
                doctorList: sorted_doctor_list,
                center_list: data.center_list,
                cardiac_diagnosis: data.cardiac_diagnostic,
                insuranceType: data.insuranceType,
                appointment_length: data.appointment_length,
                pms_landline: data.pms_landline,
                pms_mobile: data.pms_mobile,
                conversation_tags_data: data.conversation_tags_data,
                conversation_context: data?.conversation_context,
                gp_appointment_type: data.gp_appointment_type ?? "",
                birth_sex: data.birth_sex ?? ""
            };
        });

        //NOTE:- Center List
        let centerListArry = [];
        data?.center_list &&
            data?.center_list.forEach((item) =>
                centerListArry.push({
                    center_name: item.center_prefix
                        ? `${item.center_prefix} -${item.center_name}`
                        : item.center_name,
                    center_id: item.center_id,
                })
            );
        setCenterList(() => [...centerListArry]);

        if (data.schedule_datetime && data.schedule_datetime != "None") {
            setSelectDateTime(new Date(data.schedule_datetime));
        } else {
            setSelectDateTime(null);
        }

        if (data.schedule_datetime_2 && data.schedule_datetime_2 != "None") {
            setSelectDateTime2(new Date(data.schedule_datetime_2));
        } else {
            setSelectDateTime2(null);
        }


        let DOBirth = moment(data.date_of_birth);

        setOrderObj((prevState) => {
            return {
                ...prevState,
                first_name: data.first_name,
                last_name: data.last_name,
                DOB:
                    moment(DOBirth).format("DD/MM/YYYY") === "Invalid date"
                        ? ""
                        : moment(DOBirth).format("DD/MM/YYYY"),

                contact: data["mobile_number"],
                operatorFeedbackOptions: data.operator_feedback_options,
                call_status: data.call_status,
                centerId: data.center_id,
                initiator_source: data.initiator_source,
                center_list: data?.center_list,
                is_center_details_confirmed: data?.is_center_details_confirmed,
                comment: data?.feedback,
                initiatorSource: data?.initiator_source,
                request_log: data.request_log,
                reason_for_manual_booking: data?.reason_for_manual_booking,
            };
        });
        setShowCallStatusCode(data.operator_feedback);
    };

    //This function retrun true if orderStatus is 1001,1002,1004,2004,3007 and value is not empty else return the false
    function checkSuccessfulOrderStatusCode(value) {
        if (
            value === "" &&
            [1001, 1002, 1004, 2004, 3007].includes(Number(orderObj.CallStatusCode))
        ) {
            return true;
        }

        return false;
    }

    const sendAppointmentDataFunc = (event) => {
        if (
            orderObj.CallStatusCode === "--Select--" ||
            orderObj.CallStatusCode === undefined
        ) {
            SetErrorForDisplay({
                severity: "warning",
                message: "Please select Call Status.",
            });
            return;
        }

        if (checkSuccessfulOrderStatusCode(orderObj.order_description)) {
            SetErrorForDisplay({
                severity: "warning",
                message: "Order Description is mandatory.",
            });
            return;
        }
        if (checkSuccessfulOrderStatusCode(orderObj.modality)) {
            SetErrorForDisplay({
                severity: "warning",
                message: "Please reconfirm Order Description. Modality is mandatory.",
            });
            return;
        }
        if (checkSuccessfulOrderStatusCode(orderObj.bodypart)) {
            SetErrorForDisplay({
                severity: "warning",
                message: "Please reconfirm Order Description. Bodypart is mandatory.",
            });
            return;
        }

        let conversation_id = conversationID;

        let appointedDateTime = null;
        if (selectDateTime) {
            appointedDateTime = moment(new Date(selectDateTime)).format("YYYY-MM-DD HH:mm:ss");
        }

        let appointedDateTime2 = null;
        if (selectDateTime2) {
            appointedDateTime2 = moment(new Date(selectDateTime2)).format("YYYY-MM-DD HH:mm:ss");
        }

        //NOTE:- converting dd-mm-yyyy to yyyy-mm-dd
        let DateOfBirth = "";
        if (orderObj.DOB) {
            let [day, month, year] = orderObj.DOB.split("/");

            DateOfBirth = `${year}-${month}-${day}`;
        }

        let initialorder = {
            modality: orderObj.modality,
            bodypart: orderObj.bodypart,

            schedule_datetime: selectDateTime != null ? appointedDateTime : "",
            bodypart_group: orderObj.bodypartGroup,
            laterality: orderObj.laterality,
            purpose_of_study: orderObj.purposeOfStudy,
            protocol: orderObj.protocol,
            order_description: orderObj.order_description,
            roomName: orderObj.roomName,
            appointment_length: orderObj.appointment_length,
            ris_service_code: orderObj.ris_service_code,
            reserved_slot_text: orderObj.reserved_slot_text,
            is_pregnancy_flow: orderObj.is_pregnancy_flow,
            weeks_since_pregnant: orderObj.weeks_since_pregnant,
            modality_generic: orderObj.modalityGeneric,
            bodypart_generic: orderObj.bodypartGeneric,
            protocol_generic: orderObj.protocolGeneric,
            purpose_of_study_generic: orderObj.purposeOfStudyGeneric,
            laterality_generic: orderObj.lateralityGeneric,
            bodypart_group_generic: orderObj.bodypartGroupGeneric,
            speciality: orderObj.speciality,
        };
        let initialorder2= {
            modality: orderObj.modality,
            bodypart: orderObj.bodypart,

            schedule_datetime: selectDateTime2 != null ? appointedDateTime2 : "",
            bodypart_group: orderObj.bodypartGroup,
            laterality: orderObj.laterality,
            purpose_of_study: orderObj.purposeOfStudy,
            protocol: orderObj.protocol,
            order_description: orderObj.order_description,
            roomName: orderObj.roomName_2,
            appointment_length: orderObj.appointment_length_2,
            ris_service_code: orderObj.ris_service_code_2,
            reserved_slot_text: orderObj.reserved_slot_text_2,
            is_pregnancy_flow: orderObj.is_pregnancy_flow,
            weeks_since_pregnant: orderObj.weeks_since_pregnant,
            modality_generic: orderObj.modalityGeneric,
            bodypart_generic: orderObj.bodypartGeneric,
            protocol_generic: orderObj.protocolGeneric,
            purpose_of_study_generic: orderObj.purposeOfStudyGeneric,
            laterality_generic: orderObj.lateralityGeneric,
            bodypart_group_generic: orderObj.bodypartGroupGeneric,
            speciality: orderObj.speciality,
        };

        let toSendItemList = [];
        let ErrorCheck = false;
        toSendItemList.push(initialorder);
        if(orderObj.roomName_2){
            toSendItemList.push(initialorder2);
        }
        if (orderListArray.length !== 0) {
            // arr.push(addMoreOrder);
            orderListArray.forEach((item) => {
                if (item.order_description === "") {
                    SetErrorForDisplay({
                        severity: "warning",
                        message:
                            "Additional Order: Order Description is mandatory.",
                    });
                    ErrorCheck = true;
                    return;
                }
                if (item.modality === "") {
                    SetErrorForDisplay({
                        severity: "warning",
                        message: "Additional Order: Please reconfirm Order Description. Modality is mandatory.",
                    });
                    ErrorCheck = true;
                    return;
                }
                if (item.bodypart === "") {
                    SetErrorForDisplay({
                        severity: "warning",
                        message: "Additional Order: Please reconfirm Order Description. Bodypart is mandatory.",
                    });
                    ErrorCheck = true;
                    return;
                }


                // let appointmenttime_date=  item.schedule_datetime.ToString("yyyy-MM-dd HH:mm:ss");
                let SelectedDateTimeZone = new Date(item.schedule_datetime);

                // let month = SelectedDateTimeZone.getMonth() + 1;
                // let year = SelectedDateTimeZone.getFullYear();
                // let date = SelectedDateTimeZone.getDate();

                // let finalDate = `${year}-${month}-${date}`;

                // let TimeTaken = new Date(item.schedule_datetime).toTimeString();

                // let TimeTakenSplit = TimeTaken.split(" ");

                let appointedDateTime = moment(new Date(item.schedule_datetime)).format("YYYY-MM-DD HH:mm:ss") // `${finalDate} ${TimeTakenSplit[0]}`;

                let appointedDateTime2 = moment(new Date(item.schedule_datetime_2)).format("YYYY-MM-DD HH:mm:ss") // `${finalDate} ${TimeTakenSplit[0]}`;
                console.log("appointedDateTime:",appointedDateTime)
                toSendItemList.push({
                    modality: item.modality,
                    bodypart: item.bodypart,
                    protocol: item.protocol,
                    purpose_of_study: item.purpose_of_study,
                    laterality: item.laterality,
                    bodypart_group: item.bodypart_group,
                    order_description: item.order_description,
                    roomName: item.roomName,
                    ris_service_code: item.ris_service_code,
                    is_pregnancy_flow: item.is_pregnancy_flow,
                    weeks_since_pregnant: item.weeks_since_pregnant,
                    modality_generic: item.modalityGeneric,
                    bodypart_generic: item.bodypartGeneric,
                    protocol_generic: item.protocolGeneric,
                    purpose_of_study_generic: item.purposeOfStudyGeneric,
                    laterality_generic: item.lateralityGeneric,
                    bodypart_group_generic: item.bodypartGroupGeneric,
                    speciality: item.speciality,
                    appointment_length: item.appointment_length,
                    schedule_datetime: appointedDateTime,
                });
                if(item.roomName_2){
                    toSendItemList.push({
                        modality: item.modality,
                        bodypart: item.bodypart,
                        protocol: item.protocol,
                        purpose_of_study: item.purpose_of_study,
                        laterality: item.laterality,
                        bodypart_group: item.bodypart_group,
                        order_description: item.order_description,
                        roomName: item.roomName_2,
                        ris_service_code: item.ris_service_code_2,
                        is_pregnancy_flow: item.is_pregnancy_flow,
                        weeks_since_pregnant: item.weeks_since_pregnant,
                        modality_generic: item.modalityGeneric,
                        bodypart_generic: item.bodypartGeneric,
                        protocol_generic: item.protocolGeneric,
                        purpose_of_study_generic: item.purposeOfStudyGeneric,
                        laterality_generic: item.lateralityGeneric,
                        bodypart_group_generic: item.bodypartGroupGeneric,
                        speciality: item.speciality,
                        schedule_datetime: appointedDateTime2,
                        appointment_length: item.appointment_length_2,
                    });
                }
            });
            // arr.push(orderListArray);
        }

        if (ErrorCheck) {
            return;
        }

        /*
            Checking the patient list in the comrad , if we do not have the patient guidance id then we show an pop up to see the all patient in the comrad based on 
            the DOB
        
            */
        if (
            (orderObj.pms_patient_guidance_id === null || !orderObj.pms_patient_guidance_id) &&
            SuccessfulCallOrderStatus.includes(parseInt(orderObj.CallStatusCode)) &&
            !orderObj.img_appointment_id && orderObj.aIAllowedToBookAppointmentInClientDatabase
        ) {
            setPopupVisible(true);
            setPauseAudio(true);
            return;
        }




        /* Checking the guideline text'
    if we selected the guideline ,and we did not get any guideline or got any error , then do not allow to save the order
    until we get the proper guideline
    
    */

        if (
            (orderObj.preparation_id &&
                orderObj.PreparationResponse?.error_code === 0 &&
                !orderObj.PreparationResponse?.preparation_guideline_text) ||
            orderObj.PreparationResponse?.error_code < 0
        ) {
            SetErrorForDisplay({
                severity: "warning",
                message: orderObj.PreparationResponse?.error_description
                    ? orderObj.PreparationResponse.error_description
                    : "No preparation guideline text configured.OR choose another guideline",
            });
            return;
        }

        /*
        Sending a guideline text if we got any guideline
        */
        let guideline_text = "";
        //For Auto generate guideline text
        if (
            orderObj.preparation_id === -1 &&
            orderObj.PreparationResponse?.error_code === 0 &&
            orderObj.PreparationResponse?.preparation_guideline_text
        ) {
            guideline_text = orderObj.PreparationResponse?.preparation_guideline_text;
        } else if (orderObj.PreparationResponse?.preparation_guideline_text) {
            //for not auto generate guidelines
            guideline_text = orderObj.PreparationResponse?.preparation_guideline_text;
        }

        const orderData = {
            itemlist: toSendItemList,
            conversation_id: conversation_id,
            modality: orderObj.modality,
            bodypart: orderObj.bodypart,

            schedule_datetime: selectDateTime != null ? appointedDateTime : "",
            last_name: orderObj.last_name,
            first_name: orderObj.first_name,
            DOB: DateOfBirth,
            email_id: orderObj.email_id,
            send_instructions_over_email: orderObj.send_instructions_over_email,
            feedback: orderObj.comment,
            callstatus:
                orderObj.CallStatusCode === "--Select--" ? "" : orderObj.CallStatusCode,
            mobile_number: orderObj.contact,
            is_referral_processed: orderObj.ReferralChecked,
            isOrderBooked_By_Operator: orderObj.isOrderBooked_By_Operator,
            preparation_id:
                orderObj.preparation_id === "--Select--"
                    ? null
                    : orderObj.preparation_id,

            bodypart_group: orderObj.bodypartGroup,
            laterality: orderObj.laterality,
            purpose_of_study: orderObj.purposeOfStudy,
            protocol: orderObj.protocol,
            is_referral_form_mandatory: orderObj.isReferralFormMandatory,
            order_description: orderObj.order_description,
            send_notification:orderObj.send_notification,
            operator_name: operatorName,
            operator_id: operatorEmail,
            center_id: orderObj.selectedCenterId,
            weeks_since_pregnant: orderObj.weeks_since_pregnant,
            is_pregnancy_flow: orderObj.is_pregnancy_flow,
            conversation_workflow: "IMAGING_WORKFLOW",
            patient_guidance_id: !orderObj.aIAllowedToBookAppointmentInClientDatabase ? -1 : orderObj.pms_patient_guidance_id,
            center_prefix: orderObj.center_prefix,
            modality_generic: orderObj.modalityGeneric,
            bodypart_generic: orderObj.bodypartGeneric,
            protocol_generic: orderObj.protocolGeneric,
            purpose_of_study_generic: orderObj.purposeOfStudyGeneric,
            laterality_generic: orderObj.lateralityGeneric,
            bodypart_group_generic: orderObj.bodypartGroupGeneric,
            speciality: orderObj.speciality,
            preparation_guideline_text: guideline_text,
        };

        UpdateOrderdata(orderData);
    };
    const sendGpOrderDetails = (event) => {
        if (
            orderObj.CallStatusCode === "--Select--" ||
            orderObj.CallStatusCode === undefined ||
            orderObj.CallStatusCode === null
        ) {
            SetErrorForDisplay({
                severity: "warning",
                message: "please select the call status",
            });
            return;
        }

        if (
            orderObj.CallStatusCode &&
            (orderObj.CallStatusCode === 1001 ||
                orderObj.CallStatusCode === 1002 ||
                orderObj.CallStatusCode === 2004 ||
                orderObj.CallStatusCode === 3007)
        ) {
            if (orderObj.first_name == null || orderObj.first_name.length === 0) {
                SetErrorForDisplay({
                    severity: "warning",
                    message: "Please type the first name",
                });
                return;
            } else if (orderObj.DOB == null || orderObj.DOB.length === 0) {
                SetErrorForDisplay({
                    severity: "warning",
                    message: "Please type date of birth",
                });
                return;
            } else if (
                gpOrderDetails.doctor_pms_ref_id == null
            ) {
                SetErrorForDisplay({
                    severity: "warning",
                    message: "Please select the doctor",
                });
                return;
            } else if (
                (gpOrderDetails.insuranceType == null ||
                    gpOrderDetails.insuranceType.length === 0)
            ) {
                SetErrorForDisplay({
                    severity: "warning",
                    message: "Please select the insuranceType",
                });
                return;
            } else if (
                (selectDateTime === null || selectDateTime === undefined) &&
                (GpServicesToShowDoctorList.includes(
                    gpOrderDetails.gp_requested_service
                ) ||
                    !gpOrderDetails.gp_requested_service)
            ) {
                SetErrorForDisplay({
                    severity: "warning",
                    message: "Please select the appointment date",
                });
                return;
            } else if (
                gpOrderDetails.gp_requested_service === "CARDIAC_DIAGNOSTIC_TEST" &&
                !gpOrderDetails.cardiac_diagnosis
            ) {
                SetErrorForDisplay({
                    severity: "warning",
                    message: "Please select the cardiac diagnosis ",
                });
                return;
            }
        }

        let DateOfBirth = "";
        if (orderObj.DOB) {
            let [day, month, year] = orderObj.DOB.split("/");

            DateOfBirth = `${day}-${month}-${year}`;
        }

        // let appointedDateTime = null;
        let appDate = "";
        let appTime = "";
        if (selectDateTime) {
            let SelectedDateTimeZone = new Date(selectDateTime);

            let month = SelectedDateTimeZone.getMonth() + 1;
            let year = SelectedDateTimeZone.getFullYear();
            let date = SelectedDateTimeZone.getDate();

            appDate = `${date}-${month}-${year}`;

            let TimeTaken = new Date(selectDateTime).toTimeString();

            let TimeTakenSplit = TimeTaken.split(" ");
            let Time = TimeTakenSplit[0].split(":");
            appTime = `${Time[0]}:${Time[1]}`;

            // appointedDateTime = `${finalDate} ${TimeTakenSplit[0]}`;
        }

        //Checking the Order to be book manualy or not

        if (
            gpOrderDetails.pms_patient_guidance_id === null &&
            SuccessfulCallOrderStatus.includes(parseInt(orderObj.CallStatusCode)) &&
            !gpOrderDetails.bp_appointment_id
        ) {
            // Opening the check patient UI
            setPopupVisible(true);
            return;
        }

        const { OrderStatus, OrderConfirmed, updateCallStatus } =
            getOrderStatusDetails(orderObj.CallStatusCode);

        let orderData = {
            conversationID: conversationID,
            OrderSummary: "",
            appDate: appDate,
            appTime: appTime,
            patientFName: orderObj.first_name,
            patientLName: orderObj.last_name,
            patientDOB: DateOfBirth,
            Comments: orderObj.comment,
            OrderConfirmed: OrderConfirmed,

            updateCallStatus: updateCallStatus,
            OrderStatus: orderObj.CallStatusCode === "--Select--" ? "" : OrderStatus,
            ConversationWorkflow: "GP_WORKFLOW",
            doctor_pms_ref_id: gpOrderDetails.doctor_pms_ref_id,
            insuranceType: gpOrderDetails.insuranceType,
            insuranceNumber:
                gpOrderDetails.insuranceType === "CASH"
                    ? ""
                    : gpOrderDetails.insuranceNumber,
            patientMobileNumber: orderObj.contact,
            doctorName: "",
            cardiacDiagnosis: gpOrderDetails.cardiac_diagnosis,
            gpRequestedService: gpOrderDetails.gp_requested_service,
            operatorName: operatorName,
            operatorId: operatorEmail,
            pms_patient_guidance_id: gpOrderDetails.pms_patient_guidance_id ,
            centerId: orderObj.centerId,
            appointment_length: gpOrderDetails.appointment_length,
            pms_landline: gpOrderDetails.pms_landline,
            pms_mobile: gpOrderDetails.pms_mobile,
            gp_appointment_type: gpOrderDetails.gp_appointment_type || null,
            birth_sex: gpOrderDetails.birth_sex || null,
            pms_patient_id: gpOrderDetails.pms_patient_id,
        };

        UpdateOrderdata(orderData);
    };

    const orderHandler = (event) => {
        // event.preventDefault();
        if (workFlowIdentifier === "GP_WORKFLOW") {
            sendGpOrderDetails(event);
        } else {
            sendAppointmentDataFunc(event);
        }
    };

    const UpdateOrderdata = async (orderData) => {
        const condition = navigator.onLine ? "online" : "offline";
        setIsOrderBeingSave(true);
        const token = await getTokenFunc();
        if (conversationID !== "") {
            // alert("Entered");
            // API_URL

            if (orderData.preparation_id === '') {
                orderData.preparation_id = null
            }

            let URL =
                workFlowIdentifier !== "GP_WORKFLOW"
                    ? `${API_URL}/oi/api/v1/updateorderdetails`
                    : `${API_URL}/oi/api/v2/updateOrderDetails`;
            fetch(URL, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(orderData),
                credentials: "include"
            })
                .then(function (response) {
                    if(response?.status==401 || response?.status==403){
                      console.log("Session-Manger-Session-Timeout");
                      LogoutFunc()
                    }
                    return response.json();
                })
                .then((data) => {
                    setIsOrderBeingSave(false);

                    if (data.error_code === "0" || data.ErrorCode == 0) {
                        //  if(Number(orderObj.CallStatusCode).includes[1007,2006,3005]){
                        //   SetSelectedWorkdeskConversation({
                        //     conversation_id: null,
                        //   })
                        //  }

                        let orderTimes = orderSaved.length + 1;
                        setOrderSaved((prevState) => [...prevState, orderTimes]);
                        setStatusCode(orderObj.CallStatusCode);

                        showtestcallfunc(true);

                        setStatusCode(orderObj.CallStatusCode);
                        //When we save the  test call , we are making the null to the selected conversation in the redux store
                        if (
                            orderObj.CallStatusCode == 1007 ||
                            orderObj.CallStatusCode == 2006 ||
                            orderObj.CallStatusCode == 3005
                        ) {
                            SetSelectedWorkdeskConversation({
                                conversation_id: null,
                            });
                            if (pageName === "callhistory" || pageName === "Trashcall") {
                                onSaveFetchingAllCallList();
                            }
                        } else {
                            // On saving the order Refreshing the
                            if (pageName === "callhistory" || pageName === "Trashcall") {
                                resetAllStateVariables();
                                fetchOrderDetails();
                            }
                        }
                        SetErrorForDisplay({
                            severity: "success",
                            message: "Order saved successfully",
                        });
                       if (user?.oi_profile?.toLowerCase() == "customer" ){
                        updateCallStatusInCallCard(conversationID,orderObj.CallStatusCode)
                       }
                    } else {
                        if (workFlowIdentifier === "GP_WORKFLOW") {
                            SetErrorForDisplay({
                                severity: "warning",
                                message: data.ErrorDesc,
                            });
                        } else {
                            // if(data.error_code==="COM101"){
                            //   setcomradErrorList([...data.data])
                            // }

                            SetErrorForDisplay({
                                severity: "warning",
                                message: data.error_description,
                            });
                        }
                        setGpOrderDetails((prevState) => {
                            return {
                                ...prevState,
                                pms_patient_guidance_id: null,
                            };
                        });
                    }
                })
                .catch((error) => {
                    setIsOrderBeingSave(false);

                    if (condition === "offline") {
                        SetErrorForDisplay({
                            severity: "warning",
                            message: "You seem to be offline",
                        });
                    } else {
                        console.log("Error", error.message);
                        SetErrorForDisplay({
                            severity: "warning",
                            message: "Failed to save an order",
                        });
                    }
                    setGpOrderDetails((prevState) => {
                        return {
                            ...prevState,
                            pms_patient_guidance_id: null,
                        };
                    });
                    setOrderObj((prevState) => {
                        return { ...prevState, PostError: true, SaveClicked: false };
                    });
                    // setOrderObj({ ...orderObj, SaveClicked: false });
                });
        }
    };
    const [show_pediatrician, setPediatrician] = useState(false)
    const [patient_age, showPatientAge] = useState('')

    const inputChangedHandler = (event, inputIdentifier) => {
        if (inputIdentifier == 'DOB') {

            if (event.target.value.length == 10) {
                let age = Math.floor(moment(new Date()).diff(moment(event?.target?.value, "DD/MM/YYYY"), 'years', true))
                if (age < 12 && age > 0) {
                    setPediatrician(true)
                    showPatientAge(age)

                }



            }
            else {
                setPediatrician(false)
            }




        }



        if (inputIdentifier === "CallStatusCode") {
            setShowCallStatusCode(event.target.value);
        }
        if (inputIdentifier === "order_description") {
            setOrderObj((prevState) => {
                return {
                    ...prevState,
                    preparation_id: "",
                    preparation_guideline_text: ""
                }
            })
            clearTimeout(searchDescriptionTimerId);
            setSearchDescriptionTimerId(null);
            fetchScanTypeDetails(event.target.value)
        }
        if (inputIdentifier === 'contact') {
            if (event.target.value.startsWith('0')) {
                event.target.value = '+61'
            }
            if (event.target.value.startsWith('+610')) {
                event.target.value = '+61'

            }

        }


        setOrderObj((prevState) => {
            return {
                ...prevState,
                [inputIdentifier]:
                    inputIdentifier === "roomName"
                        ? event.target.value.toUpperCase()
                        : event.target.value,
            };
        });
        // Removing the comrad error if we chnage the input value
        setcomradErrorList([]);
    };

    const ReferalProcess = async (e) => {
        setOrderObj((prevState) => {
            return { ...prevState, ReferralChecked: !orderObj.ReferralChecked };
        });
    };

    useEffect(() => {
        OrderValidation(orderObj.CallStatusCode);
    }, [orderObj.CallStatusCode]);

    const ReferralrequestHandler = async (conversationID) => {
        const token = await getTokenFunc();
        if (conversationID !== "") {
            fetch(`${API_URL}/oi/api/v1/referral-link`, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    conversation_id: conversationID,
                }),
                redirect: "follow",
                credentials: "include"
            })
                .then((response) => {
                    if (response.status === 200) {
                    }
                    return response.json();
                })
                .then((data) => {
                    if (parseInt(data.error_code) !== 0) {
                        console.log("Error", data.error_description);
                        SetErrorForDisplay({
                            severity: "warning",
                            message: data.error_description,
                        });
                    } else {
                        let orderTimes = orderSaved.length + 1;
                        setOrderSaved((prevState) => [...prevState, orderTimes]);

                        // setOrderSaved((prevState) => !prevState);
                        SetErrorForDisplay({
                            severity: "success",
                            message: "Referral Request Sent",
                        });
                    }
                })
                .catch((error) => {
                    SetErrorForDisplay({ severity: "warning", message: error.message });
                });
        }
    };

    const switchCallConcludedStatus = async (conversationID) => {
        const token = await getTokenFunc();
        if (conversationID !== "") {
            fetch(`${API_URL}/oi/api/v1/conclude-call`, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    conversation_id: conversationID,
                }),
                redirect: "follow",
                credentials: "include"
            })
                .then((response) => {
                    return response.json();
                })
                .then((data) => {
                    if (parseInt(data.error_code) !== 0) {
                        console.log("Error", data.error_description);
                        SetErrorForDisplay({
                            severity: "warning",
                            message: data?.error_description ?data?.error_description:`${data?.detail}, Please try after 1 minute.`,
                        });
                    } else {
                        SetErrorForDisplay({
                            severity: "success",
                            message: "Call successfully moved",
                        });
                    }
                })
                .catch((error) => {
                    SetErrorForDisplay({ severity: "warning", message: error.message });
                });
        }
    };

    const guidelineHandler = async () => {
        if (!orderObj.preparation_id || 0 === orderObj.preparation_id.length) {
            SetErrorForDisplay({
                severity: "warning",
                message: "Please select a Guideline before sending",
            });
            return;
        }
        if (
            orderObj.preparation_id &&
            orderObj.PreparationResponse?.error_code === 0 &&
            !orderObj.PreparationResponse?.preparation_guideline_text
        ) {
            SetErrorForDisplay({
                severity: "warning",
                message: orderObj.PreparationResponse?.error_description,
            });
            return;
        }

        ClearErrorForDisplay();

        setOrderObj((prevState) => {
            return { ...prevState, guidelineRequest: true };
        });
        const token = await getTokenFunc();
        if (conversationID !== "") {
            fetch(`${API_URL}/oi/api/v1/send-preparation-guideline`, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    conversation_id: conversationID,
                    preparation_id: orderObj.preparation_id,
                    preparation_guideline_text:
                        orderObj.PreparationResponse?.preparation_guideline_text,
                }),
                redirect: "follow",
                credentials: "include"
            })
                .then((response) => {
                    if (response.status === 200) {
                        setRefRequestError({
                            error_code: 0,
                            error_description: "",
                        });
                        setOrderObj((prevState) => {
                            return { ...prevState, guidelineRequest: false };
                        });
                    }
                    if (response.status === 422) {
                        setRefRequestError({
                            error_code: 422,
                            error_description: "Conversation Id is not Selected",
                        });
                        return;
                    }

                    return response.json();
                })
                .then((data) => {
                    setRefRequestError({
                        ...refRequestError,
                        error_code: data.error_code,
                        error_description: data.error_description,
                    });
                    if (parseInt(data.error_code) !== 0) {
                        SetErrorForDisplay({
                            severity: "warning",
                            message: data.error_description,
                        });
                    } else {
                        let orderTimes = orderSaved.length + 1;
                        setOrderSaved((prevState) => [...prevState, orderTimes]);

                        // setOrderSaved((prevState) => !prevState);
                        SetErrorForDisplay({
                            severity: "success",
                            message: "Guidelines sent",
                        });
                    }
                })
                .catch((error) => {
                    SetErrorForDisplay({ severity: "warning", message: error.message });
                });
        }
    };

    const callDisconnectHandler = async () => {
        const token = await getTokenFunc();
        if (conversationID !== "") {
            fetch(`${API_URL}/oi/api/v1/call-disconnect`, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    conversation_id: conversationID,
                }),
                redirect: "follow",
                credentials: "include"
            })
                .then((response) => {
                    return response.json();
                })
                .then((data) => {
                    if (parseInt(data.error_code) !== 0) {
                        console.log("Error", data.error_description);
                        SetErrorForDisplay({
                            severity: "warning",
                            message: data.error_description,
                        });
                    } else {
                        setShowDisconnectButton((prevState) => !prevState);
                        SetErrorForDisplay({
                            severity: "success",
                            message: "Call disconnected successfully",
                        });
                    }
                })
                .catch((error) => {
                    SetErrorForDisplay({ severity: "warning", message: error.message });
                });
        }
    };

    const showSaveButton = () => {
        return (
            <Button
                type="submit"
                variant="success"
                disabled={isScanSearchBeingProcess || isPreparationGuidelineLoading}
                // disabled={orderObj.callStatus.length === 0 ? true : false}
                onClick={orderHandler}
            >
                {isOrderBeingSave ? "saving order ...." : "save"}
            </Button>
        );
    };

    const showChangeCallConcludeStatusButton = () => {
        if (
            workFlowIdentifier === "GP_WORKFLOW" &&
            orderObj.call_status !== "IN_PROGRESS" &&
            pageName === "callhistory"
        ) {
            return (
                <Button
                    variant="warning"
                    onClick={() => switchCallConcludedStatus(conversationID)}
                >
                    Move Call
                </Button>
            );
        } else {
            if (
                ((orderObj.isReferralFormMandatory &&
                    ReferralPresent === "Referral_re_request" ||
                    ReferralPresent === "Pending" ||
                    ReferralPresent === "Not_Applicable") ||
                    ReferralPresent === "Processed"
                )
            ) {
                return (
                    <Button
                        variant="warning"
                        onClick={() => switchCallConcludedStatus(conversationID)}
                    >
                        Move Call
                    </Button>
                );
            }
        }
    };

    const showReferralButton = () => {
        if (isProvisionalBooking() === true) {
            return (<></>);
        }
        if (isOrderSuccessFulCallStatusCode()) {
            return (
                <Button
                    variant="info"
                    disabled={orderObj.ReferralbuttonHandle}
                    onClick={() => ReferralrequestHandler(conversationID)}
                >
                    Request Ref.
                </Button>
            );
        }
    };

    const showSendGuidelineButton = () => {
        if (isProvisionalBooking() === true) {
            return (<></>);
        }
        if (isOrderSuccessFulCallStatusCode()) {
            return (
                <Button variant="info" onClick={guidelineHandler}>
                    Send Guideline
                </Button>
            );
        }
    };

    const showDisconnectCallButton = () => {
        if (orderObj.call_status === "IN_PROGRESS") {
            return (
                <Button variant="danger" onClick={callDisconnectHandler}>
                    Disconnect Call
                </Button>
            );
        }
    };

    const appointmentConfirmation = async () => {
        const token = await getTokenFunc();
        if (conversationID !== "") {
            fetch(`${API_URL}/oi/api/v1/appointment-confirmation`, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    conversation_id: conversationID,
                }),
                redirect: "follow",
                credentials: "include"
            })
                .then((response) => {
                    if (response.status === 200) {
                    }
                    return response.json();
                })
                .then((data) => {
                    if (parseInt(data.error_code) !== 0) {
                        console.log("Error", data.error_description);
                        SetErrorForDisplay({
                            severity: "warning",
                            message: data.error_description,
                        });
                    } else {
                        let orderTimes = orderSaved.length;
                        setOrderSaved((prevState) => [...prevState, orderTimes]);

                        // setOrderSaved((prevState) => !prevState);
                        SetErrorForDisplay({
                            severity: "success",
                            message: "Appointment confirmation sent",
                        });
                    }
                })
                .catch((error) => {
                    SetErrorForDisplay({ severity: "warning", message: error.message });
                });
        }
    };

    const showSendAppointmentConfirmation = () => {
        if (isProvisionalBooking() === true) {
            return (<></>);
        }
        if (isOrderSuccessFulCallStatusCode()) {
            return (
                <Button
                    variant="success"
                    // disabled={orderObj.ReferralbuttonHandle}
                    onClick={appointmentConfirmation}
                >
                    Appointment conf.
                </Button>
            );
        }
    };

    //Showing  all order button based on the operator selected status
    const isOrderSuccessFulCallStatusCode = () => {
        if (
            orderObj.CallStatusCode &&
            (Number(orderObj.CallStatusCode) === 1001 ||
                Number(orderObj.CallStatusCode) === 1002 ||
                Number(orderObj.CallStatusCode) === 1004 ||
                Number(orderObj.CallStatusCode) === 1007 ||
                Number(orderObj.CallStatusCode) === 2004 ||
                Number(orderObj.CallStatusCode) === 3007 ||
                (orderObj.call_status === "ESCALATED" &&
                    orderObj.isOrderBooked_By_Operator))
        ) {
            return true;
        }
        return false;
    };
    const showAppointmentConfirmationforSMSCheckbox=()=>{
        if(isOrderSuccessFulCallStatusCode() && orderObj.CallStatusCode == 1007){
            return (
                <div style={{ display: "flex", padding: "10px 3px" }}>
                    <input
                        id="appointment_confirmation_sms"
                        type="checkbox"
                        defaultValue={orderObj.send_notification}
                        placeholder="Send Appointment Confirmation SMS"
                        onChange={(e) => {
                            setOrderObj((prevState) => {
                                return {
                                    ...prevState,
                                    send_notification: !prevState.send_notification,
                                };
                            });
                        }}
                        style={{ marginRight: "10px" }}
                    />
                    <p style={{ fontSize: "15px" , marginTop:"4px"}}>Send Appointment Confirmation SMS</p>
                </div>
            );
        }else{
            return <></>
        }
       
    }

    const showIsReferralFormMandatoryForCurrentConversationCheckbox = () => {
        if (isProvisionalBooking() === true) {
            return (<></>)
        }
        if (isOrderSuccessFulCallStatusCode()) {
            return (
                <div style={{ display: "flex", marginTop: "10px" }}>
                    <input
                        id="referral_form_mandatory_checkbox"
                        type="checkbox"
                        defaultChecked={orderObj.isReferralFormMandatory}
                        placeholder="Keep the call in Workdesk"
                        onChange={(e) => {
                            setOrderObj({
                                ...orderObj,
                                isReferralFormMandatory: !orderObj.isReferralFormMandatory,
                            });
                        }}
                        style={{ marginRight: "10px" }}
                    />
                    <p style={{ fontSize: "16px" }}>Keep the call in Workdesk</p>
                </div>
            );
        }
    };

    if (
        workFlowIdentifier !== "GP_WORKFLOW" &&
        Array.isArray(orderObj.operatorFeedbackOptions) &&
        orderObj.Operator_Feedback &&
        orderObj.Operator_Feedback !== ""
    ) {
        RemovedStatusCode = orderObj.operatorFeedbackOptions.filter((status) => {
            return (
                orderObj.Operator_Feedback.operator_feedback ===
                status.operator_feedback
            );
        });
    }

    const isProvisionalBooking = () => {
        let result = false;
        orderObj?.conversation_tags_data?.map((item) => {
            if (item?.tag_key === "PROVISIONAL_BOOKING") {
                result = true;
            }
        })
        return result;
    }
    const ShowGuideLineDropdown = () => {
        if (isProvisionalBooking() === true) {
            return (<></>);
        }
        if(orderObj?.is_service_excluded_for_preparation_guideline_check===true){
            return (<div style={{color:"red"}}>Service excluded from Preparation guidelines</div>)
        }
        if (orderObj.Guidelines !== "" && isOrderSuccessFulCallStatusCode()) {
            if(orderObj.preparation_id!="-1"){
                setOrderObj({ ...orderObj, ['preparation_id']: -1 })
            }
            return (
                <Fragment>
                   
                    {orderObj.PreparationResponse &&
                        orderObj.preparation_id &&
                        !getErrorToFetchGuideline
                        ? guidelineDetails()
                        : ""}
                </Fragment>
            );
        } else return null;
    };

    const updateCommentHandler = async () => {
        setIsCommentUpdating(true);
        const token = await getTokenFunc();
        let request_data = {
            comment: orderObj.comment,
            conversation_id: conversationID,
        };
        axios({
            method: "post",
            url: `${API_URL}/oi/api/v2/update_comment`,
            data: request_data,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        })
            .then((response) => {
                if (response.data.error_code === "0") {
                    SetErrorForDisplay({
                        severity: "success",
                        message: response.data.error_description,
                    });
                } else {
                    SetErrorForDisplay({
                        severity: "warning",
                        message: response.data.error_description,
                    });
                }

                setIsCommentUpdating(false);
            })
            .catch((error) => {
                setIsCommentUpdating(false);

                SetErrorForDisplay({
                    severity: "warning",
                    message: error.message,
                });
            });
    };

    const guidelineDetails = () => {
        return (
            <div style={{ marginBottom: "10px", borderBottom: "1px solid lightgrey" }}>
                <p style={{ marginBottom: "2px", fontSize: "14px" }}>
                    Guideline Text : {!guideLineStatus && <span>Loading..</span>}
                </p>
                <div
                    style={{
                        border: "1px solid black",
                        height: "100px",
                        overflowY: "scroll",
                        padding: "10px",
                        marginBottom: "10px"
                    }}
                >
                   
                    {guideLineDetail !== undefined &&
                        guideLineDetail.guide_line !== undefined &&
                        guideLineDetail.guide_line.length !== 0 &&
                        guideLineDetail.guide_line.map((item) => (
                            <div style={{ fontSize: "13px" }}>{item}</div>
                        ))}
                </div>
            </div>
        );
    };

    const [selectDateTime, setSelectDateTime] = useState(null);
    const [selectDateTime2, setSelectDateTime2] = useState(null);
    const handleDateTimeChange = (time) => {
        setSelectDateTime(time);
        operatorNotesFetchHandler(true);
        //Clearing the comrad data if we chnage the appointment date and time
        setcomradErrorList([]);
    };

    const dateTimePicker = (disabled) => {
        const isDisabled =disabled?disabled:user?.oi_profile && user?.oi_profile?.toLowerCase() == "customer" ;
        return (
            <MuiPickersUtilsProvider
                utils={DateFnsUtils}
                style={{ fontSize: "18px" }}
            >
                <Grid>
                    <KeyboardDateTimePicker
                        variant="dialog"
                        value={selectDateTime}
                        onChange={handleDateTimeChange}
                        emptyLabel=" "
                        onError={console.log}
                        format="dd/MM/yyyy hh:mm a"
                        disabled={isDisabled}
                    />
                </Grid>
            </MuiPickersUtilsProvider>
        );
    };
    const dateTime2Picker = (disabled) => {
        const isDisabled =disabled?disabled:user?.oi_profile && user?.oi_profile?.toLowerCase() == "customer" ;
        return (
            <MuiPickersUtilsProvider
                utils={DateFnsUtils}
                style={{ fontSize: "18px" }}
            >
                <Grid>
                    <KeyboardDateTimePicker
                        variant="dialog"
                        value={selectDateTime2}
                        // onChange={handleDateTimeChange}
                        emptyLabel=" "
                        onError={console.log}
                        format="dd/MM/yyyy hh:mm a"
                        disabled={isDisabled}
                    />
                </Grid>
            </MuiPickersUtilsProvider>
        );
    };
    const ShowTextOnOrderDeatils = (props) => {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "5px",
                }}
            >
                <p className="orderdetails__manualOrder">{props.text}</p>
            </div>
        );
    };
    const { user } = useAuth0();
    const [showMessagePopup, setShowMessagePopup] = useState(false);

    const insuranceSelectionHandler = (val) => {
        setGpOrderDetails((prevState) => {
            return {
                ...prevState,
                insuranceType: val,
            };
        });
    };

    //NOTE:- this useEffect runs whenever the description  data changes and update the modality , bodypart etc..

    const [operatorNotesShouldFetch, operatorNotesFetchHandler] = useState(false);
    const [searchDescriptionTimerId, setSearchDescriptionTimerId] =
        useState(null);



    const fetchScanTypeDetails = (order_description) => {
        let token = localStorage.getItem("MyToken");

        let timerId = setTimeout(() => {
            if (conversationID) {
                setIsScanSearchBeingProcess(true);

                axios({
                    method: "post",
                    url: API_URL + "/oi/api/v1/ScanTypeDetails",
                    data: {
                        scan_desc: order_description,
                        center_id: orderObj.centerId
                    },
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                })
                    .then((res) => {
                        let data = res.data;

                        if (data) {
                            let body_part = "";
                            if (data?.bodypart.includes(",")) {
                                let i = data.bodypart.indexOf(",");
                                body_part = data.bodypart.substr(0, i);
                            }
                            let pregnancy_week = "";
                            if (data.is_pregnancy_flow) {
                                /*
                                                if we have pregnancy weeks and scan search gives the null then we are maintaining the Pregnancy weeks 
                                                */
                                /*
                                              input tag does not take the null value , If we pass the null to the input tag , it will not reset the value because input tag accept the string
                                              --
                                              Here we are passing the string if value id nulll
                                              */
                                pregnancy_week =
                                    data?.weeks_since_pregnant === null
                                        ? orderObj.weeks_since_pregnant.trim()
                                            ? orderObj.weeks_since_pregnant.trim()
                                            : ""
                                        : data?.weeks_since_pregnant;
                            }

                            setOrderObj((prevState) => {
                                return {
                                    ...prevState,
                                    bodypart: data?.bodypart.toUpperCase(),
                                    modality: data?.modality.toUpperCase(),
                                    purposeOfStudy: data?.purpose_of_study.toUpperCase(),
                                    protocol: data?.protocol.toUpperCase(),
                                    bodypartGroup: data?.bodypart_group.toUpperCase(),
                                    laterality: data?.laterality.toUpperCase(),
                                    weeks_since_pregnant: pregnancy_week,
                                    is_pregnancy_flow: data.is_pregnancy_flow,
                                    modalityGeneric: data?.modality_generic?.toUpperCase(),
                                    bodypartGeneric: data?.bodypart_generic?.toUpperCase(),
                                    protocolGeneric: data?.protocol_generic.toUpperCase(),
                                    purposeOfStudyGeneric:
                                        data?.purpose_of_study_generic.toUpperCase(),
                                    lateralityGeneric: data?.laterality_generic.toUpperCase(),
                                    bodypartGroupGeneric:
                                        data?.bodypart_group_generic.toUpperCase(),
                                    speciality: data?.speciality.toUpperCase(),
                                };
                            });
                        } else {
                            setOrderObj((prevState) => {
                                return {
                                    ...prevState,
                                    bodypart: "",
                                    bodypart_group: "",
                                    laterality: "",
                                    modality: "",
                                    protocol: "",
                                    purpose_of_study: "",
                                    weeks_since_pregnant: "",
                                    is_pregnancy_flow: false,
                                    modalityGeneric: "",
                                    bodypartGeneric: "",
                                    protocolGeneric: "",
                                    purposeOfStudyGeneric: "",
                                    lateralityGeneric: "",
                                    bodypartGroupGeneric: "",
                                    speciality: "",
                                };
                            });
                        }
                        setIsScanSearchBeingProcess(false);
                        operatorNotesFetchHandler(true);
                    })
                    .catch((e) => {
                        console.log("Error", e);
                        SetErrorForDisplay({
                            severity: "warning",
                            message: e.message,
                        });
                        setIsScanSearchBeingProcess(false);
                        operatorNotesFetchHandler(false);
                    });
                clearTimeout(searchDescriptionTimerId);
                clearTimeout(timerId);
            }
        }, 1000);

        setSearchDescriptionTimerId(timerId);
    }

    const [showReloadConversationPopup, setShowReloadConversationPopup] = useState(false)
    // {conversationData.length == 0 &&
    //   selectedConversationId !== null &&
    //   props.CallSource !== "MANUAL" ?
    const reloadConversation = (conversation_id) => {
        // alert(conversation_id)
        history.push("/continue-call/" + conversation_id)
        // setShowReloadConversationPopup(true);
    }
    const closeReloadConversationPopup = () => {
        setShowReloadConversationPopup(false);
    }

    const [order_summary, setOrderSummary] = useState(`\nName: NA\nDOB: NA,\nPatient No: NA,\nAppointment Datetime: NA,\nCenter Name: NA,\nService Name: NA`)

    useEffect(() => {
        setOrderSummary(`\nName: ${orderObj?.first_name ? orderObj?.first_name : 'NA'} ${orderObj?.last_name ? orderObj?.last_name : ''}\nDOB: ${orderObj?.DOB ? orderObj?.DOB : 'NA'},\nPatient No: ${orderObj?.contact ? orderObj?.contact : 'NA'},\nAppointment Datetime: ${moment(selectDateTime).isValid() ? moment(selectDateTime).format('DD/MM/YYYY hh:mm A') : 'NA'},\nCenter Name: ${orderObj?.center_list ? orderObj?.center_list[0]['center_name'] : 'NA'},\nService Name: ${orderObj?.order_description ? orderObj?.order_description : 'NA'}`)
    }, [orderObj])

    const get_appointment_id = () => {
        if (workFlowIdentifier === "IMAGING_WORKFLOW") {
            return orderObj.img_appointment_id;
        }
        if (workFlowIdentifier === "GP_WORKFLOW") {
            return gpOrderDetails.bp_appointment_id;
        }
    }
    return (
        <Fragment>
            {showReloadConversationPopup &&
                <Popup visible={showReloadConversationPopup} onHiding={() => { setShowReloadConversationPopup(false); }} showTitle={false} hideOnOutsideClick={false} width={"100%"} height={"100%"} style={{ width: "100%", height: "90vh" }}>
                    {/* <div>test</div> */}
                    <ManualOrder conversation_id={state.SelectedConversationId} onCloseCallback={closeReloadConversationPopup}></ManualOrder>
                </Popup>

            }

            {/* To show the custom message */}
            {showMessagePopup && (
                <CustomMessagePopup
                    width="40%"
                    height="300"
                    title="Write SMS"
                    visible={showMessagePopup}
                    popupHandler={(val) => setShowMessagePopup(!showMessagePopup)}
                >
                    <MessageTextBox
                        shouldCleanTextArea={showMessagePopup}
                        conversation_id={conversationID}
                        dispacthRequestInfo={SetErrorForDisplay}
                        popupHandler={(val) => setShowMessagePopup(!showMessagePopup)}
                    />
                </CustomMessagePopup>
            )}
            {popupVisible && <CustomMessagePopup
                    width="75%"
                    height="870"
                    title="Existing Patient Matching / New Patient Registration"
                    visible={popupVisible}
                    popupHandler={(val) => setPopupVisible(!popupVisible)}

                >
                    <PatientList
                        centerId={orderObj.centerId}
                        orderObj={orderObj}
                        setOrderObj={(val) =>
                            setOrderObj({
                                ...orderObj,
                                ...val,
                            })
                        }
                        setGpOrderDetails={(val) =>
                            setGpOrderDetails({
                                ...gpOrderDetails,
                                ...val,
                            })
                        }
                        setPopupVisible={() => setPopupVisible(!popupVisible)}
                        dob={orderObj.DOB}
                        gpOrderDetails={gpOrderDetails}
                        popupVisible={popupVisible}
                        sendGpOrderDetails={sendGpOrderDetails}
                        appointment_to_be_booked_manually={
                            gpOrderDetails.appointment_to_be_booked_manually
                        }
                        bp_appointment_id={get_appointment_id()}
                        conversationWorkflow={workFlowIdentifier}
                        sendAppointmentDataFunc={sendAppointmentDataFunc}
                    />
                </CustomMessagePopup>}


            <div
                className="orderdetails"
                // onSubmit={orderHandler}
                style={{ overflowY: "auto" }}
            >
                {/* Commentingn out the 'Manual' flag based on the JIRA 1503,1504 */}
                {/* To show the text , to book an appointment manually  */}
                {/* {gpOrderDetails.appointment_to_be_booked_manually &&
        !gpOrderDetails.bp_appointment_id ? (
          <ShowTextOnOrderDeatils text=" To be manually booked" />
        ) : orderObj.initiatorSource === "MANUAL" ? (
          <ShowTextOnOrderDeatils text="Appointmnet details captured manually" />
        ) : (
          ""
        )} */}
              {user?.oi_profile && user?.oi_profile?.toLowerCase() !== "customer" && <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    {RELOAD_CONVERSATION_WORKFLOW === "1" && conversationID && <Button style={{ padding: "3px 10px", marginLeft: "10px" }} onClick={() => { reloadConversation(conversationID); }} >Continue conversation</Button>}
                </div> }
                <div>
                    {showDoctorCalender && (
                        <CustomModal
                            onClose={(prevState) => setShowDoctorCalender(!prevState)}
                        >
                            <BookAnAppointment
                                doctorList={gpOrderDetails.doctorList}
                                selectDoctor={(val) =>
                                    setGpOrderDetails((prevState) => {
                                        return { ...prevState, ...val };
                                    })
                                }
                                selectAppointmentTime={(val) => settime(val)}
                                onClose={(val) => setShowDoctorCalender(val)}
                                selectedAppointmentDate={(val) => setSelectDateTime(val)}
                                centerId={gpOrderDetails.center_id}
                            />
                        </CustomModal>
                    )}

                    {workFlowIdentifier === "DIRECT_CALL" &&
                        <>
                            <DirectCallOrder directCallDetails={directCallDetails} customStyle={{ width: "100%" }} />


                        </>
                    }
                    {workFlowIdentifier === "OBAI_WORKFLOW" &&
                        <>
                            OBAI Workflow
                            <div>Task ID: {obaiTaskDetails?.task_entry?.task_id}</div>
                            <div>Task Entry ID: {obaiTaskDetails?.task_entry?.id}</div>
                            <div></div>
                            <div>Name: {obaiTaskDetails?.task_entry?.patient_first_name} {obaiTaskDetails?.task_entry?.patient_last_name} </div>
                            <div>DOB: {obaiTaskDetails?.task_entry?.patient_dob}</div>
                            <div>Type: {obaiTaskDetails?.task_entry?.task_type}</div>
                            <div>Status: {obaiTaskDetails?.task_entry?.task_status}</div>
                            <div>Actioned: {(obaiTaskDetails?.task_entry?.is_actioned===null || obaiTaskDetails?.task_entry?.is_actioned===false) ?"No":"Yes"}</div>
                            <div><hr></hr></div>
                            
                            <div>subject_is_able_to_speak: <b>{obaiTaskDetails?.conversation_tags?.subject_is_able_to_speak===true?"Yes":"No"}</b></div>
                            <div>subject_is_intended_recipent: <b>{obaiTaskDetails?.conversation_tags?.subject_is_intended_recipent===true?"Yes":"No"}</b></div>
                            <div>dob_given_by_subject: <b>{obaiTaskDetails?.conversation_tags?.dob_given_by_subject===true?"Yes":"No"}</b></div>
                            <div>wants_appoinment: <b>{obaiTaskDetails?.conversation_tags?.wants_appoinment===true?"Yes":"No"}</b></div>
                            <div>remove_waltlist: <b>{obaiTaskDetails?.conversation_tags?.remove_waltlist===true?"Yes":"No"}</b></div>
                            <div>slot_accepted: <b>{obaiTaskDetails?.conversation_tags?.slot_accepted===true?"Yes":"No"}</b></div>
                            <div>correct_phone_number: <b>{obaiTaskDetails?.conversation_tags?.correct_phone_number===true?"Yes":"No"}</b></div>
                        </>
                    }

                    {workFlowIdentifier === "IMAGING_WORKFLOW" && (
                        <div style={{ marginBottom: "10px" }}>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    // justifyContent: "flex-end",
                                }}
                            >
                                {conversationID != null &&
                                    !conversationID.includes("_") &&
                                    orderObj.number_of_itemlist >= 1 && (
                                        <p className="parentOrderItem">
                                            This order has other order associated with it
                                        </p>
                                    )}
                                {conversationID != null && conversationID.includes("_") && (
                                    <div>
                                        <p className="childOrderItem">
                                            This order is a <b>child item </b> associated with the
                                            parent (
                                            <span className="parentConversationId">
                                                {getParentConversationIdFromChildOrder(conversationID)}
                                            </span>
                                            )
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Displaying the center details with Input box and drop down */}
                    {

                        orderObj.is_center_details_confirmed &&
                            centerList.length !== 0 ? (
                            <div className="section__separation">
                                <table style={{ marginBottom: "10px" }}>
                                    <tr>
                                        <td style={{ width: "15%", fontSize: "14" }}>Center:</td>
                                        <td style={{ width: "500px" }}>
                                            <Input
                                                fontSize="17px"
                                                width="100%"
                                                placeholder="center"
                                                Value={`${centerList[0].center_name}`}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        ) : null}

                    {
                        orderObj.is_center_details_confirmed === 0 && (
                            <div className="section__separation">
                                <table style={{ marginBottom: "10px" }}>
                                    <tr>
                                        <td style={{ width: "10%", fontSize: "14" }}>Center:</td>
                                        <td style={{ width: "500px" }}>
                                            <SelectBoxDropDown
                                                placeholder="Select a center"
                                                data={centerList}
                                                valueExpr="center_id"
                                                displayExpr="center_name"
                                                readOnly={true}
                                                Value={orderObj.selectedCenterId}
                                                changeHandler={(value) =>
                                                    setOrderObj({
                                                        ...orderObj,
                                                        ["selectedCenterId"]: value,
                                                    })
                                                }
                                            />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        )}
                </div>
                {user?.oi_profile && user?.oi_profile?.toLowerCase() !== "customer" && workFlowIdentifier == "IMAGING_WORKFLOW" && conversationID && orderObj.modality && (
                    <div 
                        onClick={(e) => {
                            if (fetchOperatorNotes) {
                                setFetchOperatorNotes(false)
                                operatorNotesFetchHandler(true)
                            } else {
                                setFetchOperatorNotes(true)
                            }
                        }}
                        style={{
                            color: "blue",
                            textDecoration: "underline",
                            cursor: "pointer",
                            margin: "4px 0px",
                            fontSize: "16px"
                        }}
                    >
                        {fetchOperatorNotes === false ? 'Fetch Operator Notes' : 'Hide Operator Notes'}
                    </div>)}
                {workFlowIdentifier == "IMAGING_WORKFLOW" && conversationID && orderObj.modality && fetchOperatorNotes && (
                    <OperatorHelpNotes
                        selectDateTime={selectDateTime}
                        center_id={orderObj.centerId}
                        modality={orderObj.modality}
                        bodypart={orderObj.bodypart}
                        bodypart_group={orderObj.bodypartGroup}
                        protocol={orderObj.protocol}
                        purpose_of_study={orderObj.purposeOfStudy}
                        laterality={orderObj.laterality}
                        modalityGeneric={orderObj.modalityGeneric}
                        bodypartGeneric={orderObj.bodypartGeneric}
                        protocolGeneric={orderObj.protocolGeneric}
                        purposeOfStudyGeneric={orderObj.purposeOfStudyGeneric}
                        lateralityGeneric={orderObj.lateralityGeneric}
                        bodypartGroupGeneric={orderObj.bodypartGroupGeneric}
                        speciality={orderObj.speciality}
                        order_description={orderObj.order_description}
                        pregnancyWeeks={orderObj.weeks_since_pregnant}
                        conversationID={conversationID}
                        operatorNotesShouldFetch={operatorNotesShouldFetch}
                        operatorNotesFetchHandler={(data) => {
                            operatorNotesFetchHandler(data)
                        }}

                    />
                )}


                <div className="section__separation" style={{ paddingTop: "2px" }}>

                    {/* Displaying the Description in Imaging workflow */}
                    {workFlowIdentifier === "IMAGING_WORKFLOW" && (
                        <table style={{ width: "100%" }}>
                            <tr>
                                <td
                                    style={{ width: "7%", fontSize: "16", paddingRight: "7px" }}
                                    title={"Description"}
                                >
                                    Des:
                                </td>
                                <td>
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <Input
                                            fontSize="17px"
                                            width="100%"
                                            fontStyle="uppercase"
                                            placeholder="Description"
                                            disabled={user?.oi_profile && user?.oi_profile?.toLowerCase() == "customer" && orderObj?.Operator_Feedback?.operator_feedback=="1001"}
                                            Value={orderObj.order_description}
                                            onChange={(event) =>
                                                inputChangedHandler(event, "order_description")
                                            }
                                        />
                                        {isScanSearchBeingProcess && (
                                            <img
                                                src={Loading}
                                                style={{ marginLeft: "5px", width: "30px" }}
                                            />
                                        )}
                                    </div>
                                </td>
                            </tr>
                        </table>
                    )}

                    {/*  Displaying the Appointmnet calendar for GP Workflow */}

                    {workFlowIdentifier === "GP_WORKFLOW" &&
                        (GpServicesToShowDoctorList.includes(
                            gpOrderDetails.gp_requested_service
                        ) ||
                            !gpOrderDetails.gp_requested_service) &&
                        gpOrderDetails.doctorList &&
                        gpOrderDetails.doctorList.length > 0 && (
                            <AppointmentCaldendarButton
                                onClick={(prevState) => setShowDoctorCalender(true)}
                                style={{}}
                            >
                                <span style={{ fontWeight: "bold", fontSize: "15px" }}>
                                    Appointment Calendar
                                </span>
                                <img
                                    src={GoogleCalendarIcon}
                                    alt="google_calendar_icon"
                                    style={{ width: "25px" }}
                                />
                            </AppointmentCaldendarButton>
                        )}



                    {/* Will display on imaging workflow */}
                    {user?.oi_profile?.toLowerCase() !== "customer" && workFlowIdentifier === "IMAGING_WORKFLOW" && (
                        <OrderScanDetails
                            orderObj={orderObj}
                            inputChangedHandler={inputChangedHandler}
                        />
                    )}
                    {/* Will display on imaging workflow */}

                    {/* Will display on imaging workflow */}

                    {workFlowIdentifier === "IMAGING_WORKFLOW" && (
                        <Fragment>
                            <table style={{ width: "100%" }}>
                                {orderObj.is_pregnancy_flow ? (
                                    <tr>
                                        <td
                                            title={"Pregnancy Weeks"}
                                            style={{ width: "5%", fontSize: "14" }}
                                        >
                                            Wks:
                                        </td>
                                        <td>
                                            <Input
                                                id="pregnancy_weeks"
                                                key="pregnancy_weeks"
                                                label="pregnancy_weeks"
                                                name="pregnancy_weeks"
                                                textTransform="capitalize"
                                                // width="42%"
                                                placeholder="Pregnancy weeks"
                                                customStyle={{ width: "155px" }}
                                                Value={orderObj.weeks_since_pregnant}
                                                onChange={(event) => {
                                                    setOrderObj((prevState) => {
                                                        return {
                                                            ...prevState,
                                                            weeks_since_pregnant: event.target.value,
                                                        };
                                                    });
                                                    operatorNotesFetchHandler(true);
                                                }}
                                            />
                                        </td>
                                    </tr>
                                ) : null}

                                <tr style={{ width: "100%" }}>
                                    <td colSpan={2}>
                                        <table>
                                                  {/* Room 1 */}
                                                  <RoomRow
                                                    label="RM:"
                                                    roomValue={orderObj.roomName}
                                                    slotText={orderObj.reserved_slot_text}
                                                    risCode={orderObj.ris_service_code}
                                                    appointmentLength={orderObj.appointment_length}
                                                    // datePicker={dateTimePicker}
                                                    datePicker={()=><InputNoError Value={selectDateTime ? moment(selectDateTime).format('DD/MM/YYYY hh:mm A') :""} disabled={true}/>}
                                                    onChangeField="roomName"
                                                    inputChangedHandler={inputChangedHandler}
                                                    orderObj={orderObj}
                                                  />
                                            
                                                  {/* Room 2 (Conditional) */}
                                                  {orderObj.roomName_2 && (
                                                    <RoomRow
                                                      label="RM2:"
                                                      roomValue={orderObj.roomName_2}
                                                      slotText={orderObj.reserved_slot_text_2}
                                                      risCode={orderObj.ris_service_code_2}
                                                      appointmentLength={orderObj.appointment_length_2}
                                                    //   datePicker={dateTime2Picker}
                                                      datePicker={()=><InputNoError Value={selectDateTime2? moment(selectDateTime2).format('DD/MM/YYYY hh:mm A') :""} disabled={true}/>}
                                                      onChangeField="roomName_2"
                                                      inputChangedHandler={inputChangedHandler}
                                                      orderObj={orderObj}
                                                    />
                                                  )}
                                            <tr style={{ borderTop: "1px solid lightgrey" }}>
                                                <td colSpan={9}> </td>
                                            </tr>
                                            <tr>
                                                <td colSpan={9} style={{ color: "red", margin: "auto" }}>
                                                    <div style={{ color: "black", marginBottom: "10px", marginTop: "10px" }}>
                                                        Context: {orderObj.conversation_context?.replace("_", " ")}
                                                    </div>
                                                   {user?.oi_profile && user?.oi_profile?.toLowerCase() !== "customer" && <div>
                                                    Tags:
                                                    {
                                                        orderObj.conversation_tags_data && orderObj.conversation_tags_data.map((item, i) => {
                                                            return (
                                                                <li>{item?.tag_description}</li>
                                                            )
                                                        })
                                                    }
                                                    </div>
                                                  }
                                                </td>
                                            </tr>
                                        </table>
                                    </td>

                                </tr>
                            </table>
                        </Fragment>
                    )}
                </div>
                {/* Will display on imaging workflow */}

                {workFlowIdentifier === "IMAGING_WORKFLOW" &&
                    orderListArray.length !== 0 &&
                    orderListArray.map((item, index) => (
                        <AddmoreOrder
                            centerId={orderObj.centerId}
                            key={`${index} - ${item.modality}`}
                            Id={index}
                            orderDetails={item}
                            orderListArray={orderListArray}
                            setOrderListArray={(val) => setOrderListArray(val)}
                            rerender={rerender}
                            setRerender={(val) => setRerender(val)}
                            addExtraOrderhandler={addExtraOrderhandler}
                        />
                    ))}
                {workFlowIdentifier === "GP_WORKFLOW" && (
                    <div className="section__separation">
                        <table style={{ width: "100%" }}>
                            <tr>
                                <td
                                    style={{ width: "6%", fontSize: "14" }}
                                    title={
                                        GpServicesToShowDoctorList.includes(
                                            gpOrderDetails.gp_requested_service
                                        ) || !gpOrderDetails.gp_requested_service
                                            ? "Doctor Name"
                                            : "Cardiac Diagnosis"
                                    }
                                >
                                    {GpServicesToShowDoctorList.includes(
                                        gpOrderDetails.gp_requested_service
                                    ) || !gpOrderDetails.gp_requested_service
                                        ? "Doc:"
                                        : "CD:"}
                                </td>
                                <td>
                                    <div style={{ width: "100%", marginRight: "5px" }}>
                                        {gpOrderDetails.gp_requested_service ===
                                            "CARDIAC_DIAGNOSTIC_TEST" && (
                                                <SelectBoxDropDown
                                                    placeholder="Select a cardiac diagnosis"
                                                    data={cardiacDiagnosisList}
                                                    valueExpr="value"
                                                    displayExpr="type"
                                                    Value={gpOrderDetails.cardiac_diagnosis}
                                                    changeHandler={(val) =>
                                                        setGpOrderDetails({
                                                            ...gpOrderDetails,
                                                            cardiac_diagnosis: val,
                                                        })
                                                    }
                                                />
                                            )}
                                        {(GpServicesToShowDoctorList.includes(
                                            gpOrderDetails.gp_requested_service
                                        ) ||
                                            !gpOrderDetails.gp_requested_service) && (
                                                <Input
                                                    id="doctorName"
                                                    // label="Given name"
                                                    elementType="input"
                                                    key="doctorName"
                                                    name="doctorName"
                                                    width="100%"
                                                    textTransform="capitalize"
                                                    placeholder=""
                                                    Value={gpOrderDetails.doctorName}
                                                    disabled={true}
                                                />
                                            )}
                                    </div>
                                </td>

                                {(GpServicesToShowDoctorList.includes(
                                    gpOrderDetails.gp_requested_service
                                ) ||
                                    !gpOrderDetails.gp_requested_service) && (
                                        <Fragment>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    marginLeft: "10px",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        width: "8%",
                                                        fontSize: "14",
                                                        marginRight: "5px",
                                                    }}
                                                    title={"Appointment date"}
                                                >
                                                    A.D:
                                                </div>
                                                <div
                                                    className="orderDetails__appointmentDate"
                                                    style={{
                                                        width: "100%",
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                    }}
                                                >
                                                    {dateTimePicker()}{" "}
                                                </div>
                                            </div>
                                        </Fragment>
                                    )}
                            </tr>
                        </table>
                    </div>
                )}
                {workFlowIdentifier === "IMAGING_WORKFLOW" && <ImagingOrderDetails
                    workFlowIdentifier={workFlowIdentifier}
                    orderObj={orderObj}
                    comradErrorList={comradErrorList}
                    inputChangedHandler={inputChangedHandler}
                    gpOrderDetails={gpOrderDetails}
                    show_pediatrician={show_pediatrician}
                    patient_age={patient_age}

                />}
                {workFlowIdentifier === "GP_WORKFLOW" && <GpOrderDetails
                    workFlowIdentifier={workFlowIdentifier}
                    orderObj={orderObj}
                    comradErrorList={comradErrorList}
                    inputChangedHandler={inputChangedHandler}
                    gpOrderDetails={gpOrderDetails}
                    GpServicesToShowDoctorList={GpServicesToShowDoctorList}
                    setPopupVisible={setPopupVisible}
                    popupVisible={popupVisible}
                    insuranceSelectionHandler={insuranceSelectionHandler}
                    setGpOrderDetails={setGpOrderDetails} setShowCallStatusCode={setShowCallStatusCode} setOrderObj={setOrderObj}
                    insuranceTypeList={insuranceTypeList}
                    conversationID={conversationID}
                    showCallStatusCode={showCallStatusCode}
                />}

                {/* <ErrorTable comradErrorList={comradErrorList} /> */}







                {/* FOR IMAGING WORKFLOW SHOWING THE PMS ID */}
                {workFlowIdentifier === "IMAGING_WORKFLOW" &&
                    orderObj.img_appointment_temporary_id && orderObj.img_appointment_id === '' && (
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                                justifyContent: "space-between",
                            }}
                        >
                            <div className="pms_id">
                                <div className="pms_id_text" style={{ width: "unset", background: "yellow" }} title="PMS Appointment Id">
                                    Provisional Appt. ID:
                                </div>
                                <div className="pms_id_input">
                                    <Input
                                        fontSize="17px"
                                        width="100%"
                                        placeholder="Provisional Appt. ID"
                                        Value={orderObj.img_appointment_temporary_id}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>
                    )
                }
                {workFlowIdentifier === "IMAGING_WORKFLOW" &&
                    orderObj.img_appointment_id && (
                        <Fragment>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "100%",
                                    justifyContent: "space-between",
                                }}
                            >
                                <div className="pms_id">
                                    <div className="pms_id_text" title="PMS Appointment Id">
                                        PMS ID:
                                    </div>
                                    <div className="pms_id_input">
                                        <Input
                                            fontSize="17px"
                                            width="100%"
                                            placeholder="PMS Id"
                                            Value={orderObj.img_appointment_id}
                                            disabled={true}
                                        />
                                    </div>
                                    {orderObj.img_appointment_id && orderObj.pms_patient_id !== null && orderObj.pms_patient_id != 0 && (
                                        <div
                                            className="new_existing_patient_text"
                                            style={{
                                                background: orderObj.img_appointment_new_patient_created
                                                    ? "#035D91"
                                                    : "#499F4C",
                                            }}
                                        >
                                            {orderObj.img_appointment_new_patient_created ? (
                                                <div>
                                                    {" "}
                                                    {
                                                        orderObj.pms_patient_id ?
                                                            <p style={{ marginBottom: "0px" }}>
                                                                New patient ({orderObj.pms_patient_id})
                                                            </p> :
                                                            <p style={{ marginBottom: "0px" }}>
                                                                New patient
                                                            </p>
                                                    }
                                                </div>
                                            ) : (
                                                <div>
                                                    {" "}
                                                    {orderObj.pms_patient_id ?

                                                        <p style={{ marginBottom: "0px" }}>
                                                            Existing patient ({orderObj.pms_patient_id})
                                                        </p> :
                                                        <p style={{ marginBottom: "0px" }}>
                                                            Existing patient
                                                        </p>
                                                    }
                                                </div>
                                            )}
                                        </div>

                                    )}
                                </div>
                               {user?.oi_profile?.toLowerCase() !== "customer" && <div className="checkPatient">
                                        {conversationID != null &&
                                            orderObj.img_appointment_id && (
                                                <button
                                                    className="btn btn-primary "
                                                    type="button"
                                                    onClick={() => setPopupVisible(!popupVisible)}
                                                    style={{ padding: "10px 10px" }}
                                                >
                                                    <span
                                                        style={{ fontWeight: "bold", fontSize: "10px" }}
                                                    >
                                                        Check Patient
                                                    </span>
                                                </button>
                                            )}
                                    </div>
                             }
                            <div className="section__separation"></div>
                            </div>

                        </Fragment>
                    )}


                {orderObj.call_status === "IN_PROGRESS" ? (
                    <p></p>
                ) : (
                    <Fragment>
                        {workFlowIdentifier === "IMAGING_WORKFLOW" && (
                            <div className="section__separation">
                                <table style={{ marginBottom: "5px", width: "100%" }}>
                                    <tr>
                                        <td style={{ width: "10%", fontSize: "14" }}>Status:</td>
                                        {Array.isArray(RemovedStatusCode) &&
                                            RemovedStatusCode.length === 0 && (
                                                <td
                                                    style={{
                                                        border: "1px solid black",
                                                        height: "12px",
                                                        width: "10%",
                                                    }}
                                                >
                                                    <p style={{ fontSize: "12px" }}>
                                                        {orderObj.Operator_Feedback.operator_feedback}
                                                    </p>
                                                </td>
                                            )}
                                        <td style={{ width: "500px" }}>
                                            <SelectBoxDropDown
                                                valueExpr="operator_feedback"
                                                displayExpr="operator_feedback_english"
                                                data={orderObj.operatorFeedbackOptions}
                                                Value={showCallStatusCode}
                                                disabled={(user?.oi_profile?.toLowerCase() === "customer" && ![2001, 2002, 2003, 2004, 2005, 2006, 2007,2008].includes(showCallStatusCode))?true:false}
                                                changeHandler={(value,prev_value) => {
                                                    sendNotificationHandler(value)
                                                    if (value == "1001") {
                                                        setOrderObj((prevState) => {
                                                            return {
                                                                ...prevState,
                                                                ["CallStatusCode"]: value, ['preparation_id']: isProvisionalBooking() === true ? "" : -1
                                                            };
                                                        })

                                                    }
                                                    else {
                                                        setOrderObj((prevState) => {
                                                            return {
                                                                ...prevState,
                                                                ["CallStatusCode"]: value, ['preparation_id']: ""
                                                            }
                                                        })
                                                        setGuideLineDetail({
                                                            doc_name: "",
                                                            guide_line: "",
                                                        })
                                                    }
                                                }
                                                }
                                                onChangeHandler={(value) =>
                                                    setShowCallStatusCode(value)
                                                }
                                            />
                                        </td>
                                    </tr>
                                </table>
                                {workFlowIdentifier === "IMAGING_WORKFLOW" && !initialOrderDetails?.operator_feedback &&
                                 showAppointmentConfirmationforSMSCheckbox()}
                            </div>
                        )}
                    </Fragment>
                )}
              <div>
                
                {workFlowIdentifier === "IMAGING_WORKFLOW" && user?.oi_profile?.toLowerCase() !== "customer" && (
                    <Fragment>
                        <ShowGuideLineDropdown />
                    </Fragment>
                )}

                {workFlowIdentifier === "IMAGING_WORKFLOW" && user?.oi_profile?.toLowerCase() !== "customer" &&
                    (ReferralPresent === "Available" ||
                        ReferralPresent === "Processed") && (
                        <ReferralFormProcessedCheckbox
                            ReferalProcess={ReferalProcess}
                            ReferralChecked={orderObj.ReferralChecked}
                        />
                    )}

                {/* Displaying the comment and Save buttons */}
                {workFlowIdentifier !== "DIRECT_CALL" && 
                    <div style={{ marginTop: "10px" }}>
                        <p style={{ marginRight: "10px", fontSize: "14px" }}>
                            Comments{" "}
                            {conversationID && (
                                <span>
                                    <button
                                        className="btn btn-primary"
                                        type="button"
                                        onClick={updateCommentHandler}
                                        style={{ padding: "3px 10px", marginLeft: "10px" }}
                                    >
                                        {!isCommentUpdating ? (
                                            <span style={{ fontWeight: "bold", fontSize: "10px" }}>
                                                update comment
                                            </span>
                                        ) : (
                                            <span>
                                                {" "}
                                                <span
                                                    className="spinner-border spinner-border-sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                ></span>
                                                updating...
                                            </span>
                                        )}
                                    </button>
                                    {user?.oi_profile?.toLowerCase() !== "customer" && <CustomButtonWithLoading
                                        clickHandler={() => setShowMessagePopup(true)}
                                        buttonText="message"
                                        loadingText="sending message..."
                                        Icon={
                                            <MessageIcon
                                                style={{ fontSize: "15px", marginLeft: "5px" }}
                                            />
                                        }
                                    />}
                                </span>
                            )}{" "}
                        </p>

                        <textarea
                            id="comment"
                            key="comment"
                            label="Comment"
                            elementType="comment"
                            name="comment"
                            value={orderObj.comment}
                            onChange={(event) => {
                                inputChangedHandler(event, "comment");
                            }}
                            placeholder="My Comments... "
                            style={{
                                width: "100%",
                                height: "60px",
                                fontSize: "12",
                                outline: "none",
                            }}
                        />
                    </div>
                }
              {user?.oi_profile?.toLowerCase() !== "customer" && <div style={{ marginTop: '20px' }} >
                    <TextArea label="Order Summary" value={order_summary} readOnly={false} placeholder="" maxHeight={180} height={180}></TextArea>


                </div>
            }


                {/* {workFlowIdentifier === "IMAGING_WORKFLOW" &&
                    showIsReferralFormMandatoryForCurrentConversationCheckbox()} */}
               </div>
               {user?.oi_profile?.toLowerCase() !== "customer" &&  <ButtonGroup className="ReferralButtonGroup">
                    {["IMAGING_WORKFLOW", "GP_WORKFLOW"].includes(workFlowIdentifier) && showSaveButton()}
                    {workFlowIdentifier === "IMAGING_WORKFLOW" && showReferralButton()}
                    {workFlowIdentifier === "IMAGING_WORKFLOW" && showSendGuidelineButton()}
                    {!showDisconnectButton && showDisconnectCallButton()}
                    {showChangeCallConcludeStatusButton()}
                    {workFlowIdentifier === "IMAGING_WORKFLOW" &&
                        showSendAppointmentConfirmation()}
                </ButtonGroup>
                }
              {(user?.oi_profile?.toLowerCase() === "customer"  && [2001, 2002, 2003, 2004, 2005, 2006, 2007,2008].includes(showCallStatusCode)) &&  <ButtonGroup className="ReferralButtonGroup">
                    {["IMAGING_WORKFLOW", "GP_WORKFLOW"].includes(workFlowIdentifier) && showSaveButton()}
                </ButtonGroup>
                }
                {isPreparationGuidelineLoading && <div style={{color:"red"}}>Saving Disabled. Preparation Guideline Awaited.</div>}
                    <div style={{ marginTop: "15px" }}>
                        {/* <RequestTable /> */}

                        {orderObj.request_log && orderObj.request_log.length != 0 && (
                            <RequestTable requestLog={orderObj.request_log}  server_timezone={orderObj?.server_timezone} center_timezone={orderObj?.center_timezone} />
                        )}
                    </div>
            </div>
        </Fragment>
    );
};
const mapStateToProps = (state) => {
    return {
        errorForDisplay: state.Error,
        operatorName: state.operatorName,
        operatorEmail: state.operatorEmail,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        SetErrorForDisplay: (payload) => dispatch(SetError(payload)),
        ClearErrorForDisplay: () => dispatch(ClearError()),
        setStatusCode: (code) => dispatch(StatusCode(code)),
        setDataFetchingStatus: (response) =>
            dispatch(setDataFetchingStatus(response)),
        SetSelectedWorkdeskConversation: (val) =>
            dispatch(SetSelectedWorkdeskConversation(val)),
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withAuth0(OrderDetails));
